import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    BioSicherheitPlanSchwein,
    BioSicherheitPlanSchweinReinigung,
    BioSicherheitsPlanFile,
    ReinigungFormControls,
    Reinigungseintrag,
    HandlungsempfehlungEintrag,
} from './BioSicherheitPlanSchwein';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { Benutzerprofil } from '../../../../projects/kiene-core/src/lib/components/stammdaten/mein-profil/mein-profil';
import { Subscription } from 'rxjs';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { Tierarzt } from '../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';
import {
    EnterValueInput,
    EnterValueResponse,
} from '../../../..//projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import { EnterValueDialogComponent } from '../../../..//projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { ChangeCurrentClientService } from '../../administration/client/change-current-client/change-current-client.service';

@Component({
    selector: 'kiene-bio-sicherheits-plan-schwein',
    templateUrl: './bio-sicherheits-plan-schwein.component.html',
    styleUrls: ['./bio-sicherheits-plan-schwein.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class BioSicherheitsPlanSchweinComponent implements OnInit, OnDestroy {
    @ViewChild('fileSelector3') fileSelector3: ElementRef;
    @ViewChild('fileSelector8') fileSelector8: ElementRef;
    @ViewChild('fileSelector14') fileSelector14: ElementRef;
    selectedFiles: BioSicherheitsPlanFile[] = [];

    // newFiles: BioSicherheitsPlanFile[] = [];
    isLoading = false;
    isSaving = false;

    rowspan = 3;
    bsp = new BioSicherheitPlanSchwein();
    benutzerprofil: Benutzerprofil;
    routerSub: Subscription;
    currentVet: Tierarzt;
    heute = new Date();
    timeout: NodeJS.Timeout;
    changeClientSub: Subscription;

    reinigungsplaene: Reinigungseintrag[] = [];
    handlungsempfehlungen: HandlungsempfehlungEintrag[] = [];
    // Fragen texte für die Reinigungspläne
    fc_tierarzt = new FormControl(undefined, [Validators.required]);

    fc_v1_1_datum = new FormControl(this.heute);
    fc_v1_2_verantwortlich = new FormControl();
    fc_v1_3_verantwortlich_adresse = new FormControl();
    fc_v1_4_verantwortlich_telefon = new FormControl();
    fc_v1_6_verantwortlich_email = new FormControl(undefined, [Validators.email]);
    fc_v1_5_beihilfe_tsk = new FormControl();
    fc_v1_7_steuer_optierend = new FormControl();
    fc_v1_8_steuer_pauschal = new FormControl();
    fc_beratungszeit_tierarzt = new FormControl();
    fc_beratungszeit_berater = new FormControl();
    fc_v1_9_berater_name = new FormControl();
    fc_v1_10_berater_adresse = new FormControl();
    fc_v1_11_berater_telefon = new FormControl();
    fc_v1_12_berater_email = new FormControl(undefined, [Validators.email]);
    fc_v1_13_standort_adresse = new FormControl();
    fc_v1_14_anzahl_staelle = new FormControl();
    fc_v1_15_stall_bezeichnungen = new FormControl();
    fc_v1_16_anzahl_sauenplaetze = new FormControl();
    fc_v1_17_anzahl_aufzuchtplaetze = new FormControl();
    fc_v1_18_anzahl_mastplaetze = new FormControl();
    fc_v1_19_mit_auslauf = new FormControl();
    fc_v1_20_freiland = new FormControl();
    fc_v1_21_stroh = new FormControl();
    fc_v1_22_anlage = new FormControl();
    fc_v1_23_aufstallung = new FormControl();

    //Region form-controls
    fc_v2_1_antwort = new FormControl();
    fc_v2_1_unterlage = new FormControl();
    fc_v2_2_antwort = new FormControl();
    fc_v2_2_unterlage = new FormControl();
    fc_v2_3_antwort = new FormControl();
    fc_v2_3_unterlage = new FormControl();
    fc_v2_4_antwort = new FormControl();
    fc_v2_4_unterlage = new FormControl();
    fc_v2_5_antwort = new FormControl();
    fc_v2_5_unterlage = new FormControl();
    fc_v2_6_antwort = new FormControl();
    fc_v2_6_unterlage = new FormControl();
    fc_v2_7_antwort = new FormControl();
    fc_v2_7_unterlage = new FormControl();
    fc_v2_8_antwort = new FormControl();
    fc_v2_8_unterlage = new FormControl();
    fc_v2_9_antwort = new FormControl();
    fc_v2_9_unterlage = new FormControl();
    fc_v2_10_handlungsbedarf = new FormControl();
    fc_v2_10_antwort = new FormControl();
    fc_v2_10_unterlage = new FormControl();
    fc_v2_11_handlungsbedarf = new FormControl();
    fc_v2_11_antwort = new FormControl();
    fc_v2_11_unterlage = new FormControl();
    fc_v2_12_handlungsbedarf = new FormControl();
    fc_v2_12_antwort = new FormControl();
    fc_v2_12_unterlage = new FormControl();
    fc_v3_13_unterlage = new FormControl();
    fc_v3_14_unterlage = new FormControl();
    fc_v3_15_antwort = new FormControl();
    fc_v3_16_antwort = new FormControl();
    fc_v3_15_unterlage = new FormControl();
    fc_v3_16_unterlage_ein_und_ausgaenge = new FormControl();
    fc_v3_16_unterlage_leicht_erreichbare_stellen = new FormControl();
    fc_v3_16_unterlage_sonstiges = new FormControl();
    fc_v3_17_antwort = new FormControl();
    fc_v3_17_unterlage = new FormControl();
    fc_v3_18_antwort = new FormControl();
    fc_v3_18_unterlage = new FormControl();
    fc_18_5 = new FormControl();
    fc_v3_19_antwort = new FormControl();
    fc_v3_19_unterlage_im_weissbereich = new FormControl();
    fc_v3_19_unterlage_im_schwarzbereich = new FormControl();
    fc_v3_19_unterlage_sonstiges = new FormControl();
    fc_v3_19_unterlage_sonstiges_text = new FormControl();
    fc_v3_20_antwort = new FormControl();
    fc_v3_20_unterlage = new FormControl();
    fc_v3_21_unterlage = new FormControl();
    fc_v3_21_antwort = new FormControl();
    fc_v3_22_antwort = new FormControl();
    fc_v3_22_unterlage = new FormControl();
    fc_v3_23_antwort = new FormControl();
    fc_v3_23_unterlage = new FormControl();
    fc_v3_24_antwort = new FormControl();
    fc_v3_24_unterlage = new FormControl();
    fc_23_5 = new FormControl();
    fc_24_4 = new FormControl();
    fc_24_5 = new FormControl();
    fc_v3_25_antwort = new FormControl();
    fc_v3_26_antwort = new FormControl();
    fc_v3_26_unterlage = new FormControl();
    fc_v3_27_antwort = new FormControl();
    fc_v3_27_unterlage = new FormControl();
    fc_v3_28_antwort = new FormControl();
    fc_v3_28_unterlage = new FormControl();

    fc_v5_36_handlungsbedarf = new FormControl();
    fc_v5_36_antwort = new FormControl();
    fc_v5_36_unterlage = new FormControl();
    fc_v5_37_handlungsbedarf = new FormControl();
    fc_v5_37_antwort = new FormControl();
    fc_v5_37_unterlage = new FormControl();
    fc_v5_38_handlungsbedarf = new FormControl();
    fc_v5_38_antwort = new FormControl();
    fc_v5_38_unterlage = new FormControl();
    fc_v5_39_handlungsbedarf = new FormControl();
    fc_v5_39_antwort = new FormControl();
    fc_v5_39_unterlage = new FormControl();
    fc_v5_40_handlungsbedarf = new FormControl();
    fc_v5_40_antwort = new FormControl();
    fc_v5_40_unterlage = new FormControl();
    fc_v5_41_handlungsbedarf = new FormControl();
    fc_v5_41_antwort = new FormControl();
    fc_v5_41_unterlage = new FormControl();
    fc_v5_42_handlungsbedarf = new FormControl();
    fc_v5_42_antwort = new FormControl();
    fc_v5_42_unterlage = new FormControl();
    fc_v5_43_vollstaendig = new FormControl();
    fc_v5_43_restemast = new FormControl();
    fc_v5_43_abteilweise = new FormControl();
    fc_v5_43_antwort = new FormControl();
    fc_v5_43_unterlage = new FormControl();
    fc_v5_44_kein_zukauf = new FormControl();
    fc_v5_44_eber = new FormControl();
    fc_v5_44_jungsauen = new FormControl();
    fc_v5_44_sonstige = new FormControl();
    fc_v5_44_antwort = new FormControl();
    fc_v5_44_unterlage = new FormControl();
    fc_v5_45_antwort = new FormControl();
    fc_v5_45_unterlage = new FormControl();
    fc_v5_46_antwort = new FormControl();
    fc_v5_46_unterlage = new FormControl();
    fc_v5_47_antwort = new FormControl();
    fc_v5_47_unterlage = new FormControl();
    fc_v6_48_handlungsbedarf = new FormControl();
    fc_v6_48_antwort = new FormControl();
    fc_v6_48_unterlage = new FormControl();
    fc_v6_49_handlungsbedarf = new FormControl();
    fc_v6_49_antwort = new FormControl();
    fc_v6_49_unterlage = new FormControl();
    fc_v6_50_handlungsbedarf = new FormControl();
    fc_v6_50_antwort = new FormControl();
    fc_v6_50_unterlage = new FormControl();
    fc_v6_51_handlungsbedarf = new FormControl();
    fc_v6_51_antwort = new FormControl();
    fc_v6_51_unterlage = new FormControl();
    fc_v6_52_handlungsbedarf = new FormControl();
    fc_v6_52_antwort = new FormControl();
    fc_v6_52_unterlage = new FormControl();
    fc_v6_53_handlungsbedarf = new FormControl();
    fc_v6_53_antwort = new FormControl();
    fc_v6_53_unterlage = new FormControl();
    fc_v6_54_handlungsbedarf = new FormControl();
    fc_v6_54_antwort = new FormControl();
    fc_v6_54_unterlage = new FormControl();
    fc_v7_55_handlungsbedarf = new FormControl();
    fc_v7_55_einfriedung = new FormControl();
    fc_v7_55_tore = new FormControl();
    fc_v7_55_beschilderung = new FormControl();
    fc_v7_55_auslauf = new FormControl();
    fc_v7_55_sonstiges = new FormControl();
    fc_v7_55_antwort = new FormControl();
    fc_v7_55_unterlage = new FormControl();
    fc_v7_56_handlungsbedarf = new FormControl();
    fc_v7_56_antwort = new FormControl();
    fc_v7_56_unterlage = new FormControl();
    fc_v7_57_handlungsbedarf = new FormControl();
    fc_v7_57_antwort = new FormControl();
    fc_v7_57_unterlage = new FormControl();
    fc_v7_58_handlungsbedarf = new FormControl();
    fc_v7_58_antwort = new FormControl();
    fc_v7_58_unterlage = new FormControl();
    fc_v7_59_handlungsbedarf = new FormControl();
    fc_v7_59_antwort = new FormControl();
    fc_v7_59_unterlage = new FormControl();
    fc_v8_60_antwort = new FormControl();
    fc_v8_60_unterlage = new FormControl();
    fc_v8_61_antwort = new FormControl();
    fc_v8_61_unterlage = new FormControl();
    fc_v8_62_antwort = new FormControl();
    fc_v8_62_unterlage = new FormControl();
    fc_v8_63_antwort = new FormControl();
    fc_v8_63_unterlage = new FormControl();
    fc_v8_64_antwort = new FormControl();
    fc_v8_64_unterlage = new FormControl();
    fc_v8_65_antwort = new FormControl();
    fc_v8_65_unterlage = new FormControl();
    fc_v8_66_antwort = new FormControl();
    fc_v8_66_unterlage = new FormControl();
    fc_v8_67_antwort = new FormControl();
    fc_v8_67_unterlage = new FormControl();
    fc_v8_68_antwort = new FormControl();
    fc_v8_68_unterlage = new FormControl();
    fc_v8_69_antwort = new FormControl();
    fc_v8_69_unterlage = new FormControl();
    fc_v8_70_antwort = new FormControl();
    fc_v8_70_unterlage = new FormControl();
    fc_v8_71_antwort = new FormControl();
    fc_v8_71_unterlage = new FormControl();
    fc_v8_72_antwort = new FormControl();
    fc_v8_72_unterlage = new FormControl();
    fc_v8_73_handlungsbedarf = new FormControl();
    fc_v8_73_einfriedung = new FormControl();
    fc_v8_73_geschlossen = new FormControl();
    fc_v8_73_beschilderung = new FormControl();
    fc_v8_73_auslauf = new FormControl();
    fc_v8_73_sonstiges = new FormControl();
    fc_v8_73_antwort = new FormControl();
    fc_v8_73_unterlage = new FormControl();
    fc_v8_74_handlungsbedarf = new FormControl();
    fc_v8_74_antwort = new FormControl();
    fc_v8_74_unterlage = new FormControl();
    fc_v8_75_handlungsbedarf = new FormControl();
    fc_v8_75_antwort = new FormControl();
    fc_v8_75_unterlage = new FormControl();
    fc_v8_76_handlungsbedarf = new FormControl();
    fc_v8_76_antwort = new FormControl();
    fc_v8_76_unterlage = new FormControl();
    fc_v8_77_handlungsbedarf = new FormControl();
    fc_v8_77_antwort = new FormControl();
    fc_v8_77_unterlage = new FormControl();
    fc_v8_78_handlungsbedarf = new FormControl();
    fc_v8_78_antwort = new FormControl();
    fc_v8_78_unterlage = new FormControl();
    fc_v8_79_handlungsbedarf = new FormControl();
    fc_v8_79_antwort = new FormControl();
    fc_v8_79_unterlage = new FormControl();
    fc_v8_80_handlungsbedarf = new FormControl();
    fc_v8_80_antwort = new FormControl();
    fc_v8_80_unterlage = new FormControl();
    fc_v8_81_handlungsbedarf = new FormControl();
    fc_v8_81_antwort = new FormControl();
    fc_v8_81_unterlage = new FormControl();
    fc_v8_82_handlungsbedarf = new FormControl();
    fc_v8_82_antwort = new FormControl();
    fc_v8_82_unterlage = new FormControl();
    fc_v8_83_handlungsbedarf = new FormControl();
    fc_v8_83_antwort = new FormControl();
    fc_v8_83_unterlage = new FormControl();
    fc_v8_84_handlungsbedarf = new FormControl();
    fc_v8_84_antwort = new FormControl();
    fc_v8_84_unterlage = new FormControl();
    fc_v8_85_handlungsbedarf = new FormControl();
    fc_v8_85_antwort = new FormControl();
    fc_v8_85_unterlage = new FormControl();
    fc_v8_86_handlungsbedarf = new FormControl();
    fc_v8_86_antwort = new FormControl();
    fc_v8_86_unterlage = new FormControl();
    fc_v8_87_handlungsbedarf = new FormControl();
    fc_v8_87_schleuse = new FormControl();
    fc_v8_87_ort_schleuse = new FormControl();
    fc_v8_87_antwort = new FormControl();
    fc_v8_87_unterlage = new FormControl();
    fc_v8_88_handlungsbedarf = new FormControl();
    fc_v8_88_antwort = new FormControl();
    fc_v8_88_unterlage = new FormControl();
    fc_v8_89_handlungsbedarf = new FormControl();
    fc_v8_89_antwort = new FormControl();
    fc_v8_89_unterlage = new FormControl();
    fc_v9_90_handlungsbedarf = new FormControl();
    fc_v9_90_antwort = new FormControl();
    fc_v9_90_unterlage = new FormControl();
    fc_v9_91_handlungsbedarf = new FormControl();
    fc_v9_91_antwort = new FormControl();
    fc_v9_91_unterlage = new FormControl();
    fc_v10_92_handlungsbedarf = new FormControl();
    fc_v10_92_bestandsregister = new FormControl();
    fc_v10_92_berechnung_verluste = new FormControl();
    fc_v10_92_sauenplaner = new FormControl();
    fc_v10_92_mastplaner = new FormControl();
    fc_v10_92_nach_aufzeichnungen = new FormControl();
    fc_v10_92_antwort = new FormControl();
    fc_v10_92_unterlage = new FormControl();
    fc_v10_93_handlungsbedarf = new FormControl();
    fc_v10_93_mindestens = new FormControl();
    fc_v10_93_mit_hilfe = new FormControl();
    fc_v10_93_antwort = new FormControl();
    fc_v10_93_unterlage = new FormControl();
    fc_v10_94_handlungsbedarf = new FormControl();
    fc_v10_94_antwort = new FormControl();
    fc_v10_94_unterlage = new FormControl();
    fc_v10_95_handlungsbedarf = new FormControl();
    fc_v10_95_antwort = new FormControl();
    fc_v10_95_unterlage = new FormControl();
    fc_v10_96_handlungsbedarf = new FormControl();
    fc_v10_96_antwort = new FormControl();
    fc_v10_96_unterlage = new FormControl();
    fc_v10_97_handlungsbedarf = new FormControl();
    fc_v10_97_antwort = new FormControl();
    fc_v10_97_unterlage = new FormControl();
    fc_v10_98_handlungsbedarf = new FormControl();
    fc_v10_98_antwort = new FormControl();
    fc_v10_98_unterlage = new FormControl();
    fc_v10_99_handlungsbedarf = new FormControl();
    fc_v10_99_antwort = new FormControl();
    fc_v10_99_unterlage = new FormControl();
    fc_v11_100_handlungsbedarf = new FormControl();
    fc_v11_100_mastbetrieb = new FormControl();
    fc_v11_100_zusammenschluss = new FormControl();
    fc_v11_100_ab_stall = new FormControl();
    fc_v11_100_antwort = new FormControl();
    fc_v11_100_unterlage = new FormControl();
    fc_v11_101_handlungsbedarf = new FormControl();
    fc_v11_101_antwort = new FormControl();
    fc_v11_101_unterlage = new FormControl();
    fc_v11_102_handlungsbedarf = new FormControl();
    fc_v11_102_antwort = new FormControl();
    fc_v11_102_unterlage = new FormControl();
    fc_v11_103_handlungsbedarf = new FormControl();
    fc_v11_103_antwort = new FormControl();
    fc_v11_103_unterlage = new FormControl();
    fc_v11_104_handlungsbedarf = new FormControl();
    fc_v11_104_antwort = new FormControl();
    fc_v11_104_unterlage = new FormControl();
    fc_v11_105_handlungsbedarf = new FormControl();
    fc_v11_105_antwort = new FormControl();
    fc_v11_105_unterlage = new FormControl();
    fc_v11_106_handlungsbedarf = new FormControl();
    fc_v11_106_antwort = new FormControl();
    fc_v11_106_unterlage = new FormControl();
    fc_v11_107_handlungsbedarf = new FormControl();
    fc_v11_107_antwort = new FormControl();
    fc_v11_107_unterlage = new FormControl();
    fc_v11_108_handlungsbedarf = new FormControl();
    fc_v11_108_antwort = new FormControl();
    fc_v11_108_unterlage = new FormControl();
    fc_v11_109_handlungsbedarf = new FormControl();
    fc_v11_109_antwort = new FormControl();
    fc_v11_109_unterlage = new FormControl();
    fc_v12_110_handlungsbedarf = new FormControl();
    fc_v12_110_antwort = new FormControl();
    fc_v12_110_unterlage = new FormControl();
    fc_v12_111_handlungsbedarf = new FormControl();
    fc_v12_111_antwort = new FormControl();
    fc_v12_111_unterlage = new FormControl();
    fc_v12_112_handlungsbedarf = new FormControl();
    fc_v12_112_antwort = new FormControl();
    fc_v12_112_unterlage = new FormControl();
    fc_v12_113_handlungsbedarf = new FormControl();
    fc_v12_113_antwort = new FormControl();
    fc_v12_113_unterlage = new FormControl();
    fc_v12_114_handlungsbedarf = new FormControl();
    fc_v12_114_antwort = new FormControl();
    fc_v12_114_unterlage = new FormControl();
    fc_v13_115_handlungsbedarf = new FormControl();
    fc_v13_115_antwort = new FormControl();
    fc_v13_115_unterlage = new FormControl();
    fc_v13_116_handlungsbedarf = new FormControl();
    fc_v13_116_antwort = new FormControl();
    fc_v13_116_unterlage = new FormControl();
    fc_v13_117_handlungsbedarf = new FormControl();
    fc_v13_117_antwort = new FormControl();
    fc_v13_117_unterlage = new FormControl();
    fc_v13_118_handlungsbedarf = new FormControl();
    fc_v13_118_antwort = new FormControl();
    fc_v13_118_unterlage = new FormControl();
    fc_v13_119_handlungsbedarf = new FormControl();
    fc_v13_119_antwort = new FormControl();
    fc_v13_119_unterlage = new FormControl();
    fc_v14_120_handlungsbedarf = new FormControl();
    fc_v14_120_antwort = new FormControl();
    fc_v14_120_unterlage = new FormControl();
    fc_v14_121_handlungsbedarf = new FormControl();
    fc_v14_121_antwort = new FormControl();
    fc_v14_121_unterlage = new FormControl();
    fc_v14_122_handlungsbedarf = new FormControl();
    fc_v14_122_antwort = new FormControl();
    fc_v14_122_unterlage = new FormControl();

    // Frage 123
    fc_v123_zu_nr = new FormControl();
    fc_v123_erledigt = new FormControl();
    fc_v123_schwachstelle = new FormControl();
    fc_v123_handlungsempfehlung = new FormControl();
    fc_v123_unterlage = new FormControl();

    // Frage 124
    fc_v124_zu_nr = new FormControl();
    fc_v124_erledigt = new FormControl();
    fc_v124_schwachstelle = new FormControl();
    fc_v124_handlungsempfehlung = new FormControl();
    fc_v124_unterlage = new FormControl();

    // Frage 125
    fc_v125_zu_nr = new FormControl();
    fc_v125_erledigt = new FormControl();
    fc_v125_schwachstelle = new FormControl();
    fc_v125_handlungsempfehlung = new FormControl();
    fc_v125_unterlage = new FormControl();

    // Zusätzliche Handlungsempfehlungen (dynamisch)
    fc_v126_zu_nr = new FormControl('');
    fc_v126_erledigt = new FormControl(false);
    fc_v126_schwachstelle = new FormControl('');
    fc_v126_handlungsempfehlung = new FormControl('');
    fc_v126_unterlage = new FormControl('');

    fc_v127_zu_nr = new FormControl('');
    fc_v127_erledigt = new FormControl(false);
    fc_v127_schwachstelle = new FormControl('');
    fc_v127_handlungsempfehlung = new FormControl('');
    fc_v127_unterlage = new FormControl('');

    fc_v128_zu_nr = new FormControl('');
    fc_v128_erledigt = new FormControl(false);
    fc_v128_schwachstelle = new FormControl('');
    fc_v128_handlungsempfehlung = new FormControl('');
    fc_v128_unterlage = new FormControl('');

    fc_v129_zu_nr = new FormControl('');
    fc_v129_erledigt = new FormControl(false);
    fc_v129_schwachstelle = new FormControl('');
    fc_v129_handlungsempfehlung = new FormControl('');
    fc_v129_unterlage = new FormControl('');

    fc_v130_zu_nr = new FormControl('');
    fc_v130_erledigt = new FormControl(false);
    fc_v130_schwachstelle = new FormControl('');
    fc_v130_handlungsempfehlung = new FormControl('');
    fc_v130_unterlage = new FormControl('');

    fc_v131_zu_nr = new FormControl('');
    fc_v131_erledigt = new FormControl(false);
    fc_v131_schwachstelle = new FormControl('');
    fc_v131_handlungsempfehlung = new FormControl('');
    fc_v131_unterlage = new FormControl('');

    fc_v132_zu_nr = new FormControl('');
    fc_v132_erledigt = new FormControl(false);
    fc_v132_schwachstelle = new FormControl('');
    fc_v132_handlungsempfehlung = new FormControl('');
    fc_v132_unterlage = new FormControl('');

    //endregion

    constructor(
        public dialog: MatDialog,
        private readonly messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly api: KieneBackendApiService,
        private readonly localStorageService: LocalStorageService,
        private readonly pdf: PdfViewerDesktopService,
        private readonly changeCurrentClientService: ChangeCurrentClientService,
    ) {}

    ngOnInit() {
        this.ladeBenutzerprofil();
        const id = this.route.snapshot.paramMap.get('bs_id');

        if (id === '0') {
            // neu
            const kunde = this.localStorageService.getCurrentClient();
            if (kunde) {
                this.bsp.kunde_id = kunde.kunde_id;
                this.bsp.strasse = kunde.strasse;
                this.bsp.ort = kunde.ort;
                this.bsp.plz = kunde.plz;
                this.bsp.strasse_lieferung = kunde.strasse_lieferung;
                this.bsp.ort_lieferung = kunde.ort_lieferung;
                this.bsp.plz_lieferung = kunde.plz_lieferung;
                this.bsp.tsk_nummer = kunde.tsk_nummer;
                this.bsp.kunde = kunde.bezeichnung_final;
                this.bsp.zusatz = kunde.zusatz_final;
                this.bsp.vvvo = kunde.vvvo;
            }

            this.addReinigung();
            this.setLieferadresse();
            if (this.localStorageService.currentUserIsVet()) {
                this.setCurrentUserAsTierarzt();
            }
        } else {
            this.loadPlan(Number.parseInt(id, 10));
        }

        this.routerSub = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (!this.isReadOnly() && (this.bsp.status_id === 231 || this.bsp.status_id == null)) {
                    if (this.timeout) {
                        this.saveBSP();
                    }
                }
            }
        });
    }

    ngOnDestroy() {
        this.routerSub?.unsubscribe();
        this.changeClientSub?.unsubscribe();
    }

    loadPlan(id: number) {
        const params = new HttpParams().set('bs_id', id);
        this.api.get(this.apiBaseUrl + 'biosicherheitsplan_schwein/read_one.php', params).subscribe({
            next: data => {
                this.bsp = data;
                this.aktualisiereBrowserUrl();
                if (this.bsp.bs_files?.length > 0) {
                    this.selectedFiles = this.bsp.bs_files;
                }
                if (this.bsp.tierarzt_id) {
                    this.ladeTierarzt(this.bsp.tierarzt_id);
                } else if (this.localStorageService.currentUserIsVet()) {
                    this.setCurrentUserAsTierarzt();
                }
                this.initFormControls();
                this.syncReadOnlyFormControls();
                this.ladeBspPdfs();
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden des Bio-Sicherheitsplans: ', err);
            },
        });
    }

    ladeBspPdfs() {
        if (this.bsp.bs_id) {
            this.isLoading = true;
            const params = new HttpParams().set('bs_id', this.bsp.bs_id);
            this.api.getAll(this.apiBaseUrl + 'biosicherheitsplan_schwein_dokuments/read.php', params).subscribe({
                next: value => {
                    const pdfIdByBsdId = new Map<number, number>();
                    for (const file of this.selectedFiles) {
                        if (file?.bsd_id > 0 && file?.pdf_id > 0) {
                            pdfIdByBsdId.set(file.bsd_id, file.pdf_id);
                        }
                    }
                    this.selectedFiles = (value.records ?? []).map((record: BioSicherheitsPlanFile) => {
                        if (!record?.pdf_id && record?.bsd_id > 0) {
                            const cachedPdfId = pdfIdByBsdId.get(record.bsd_id);
                            if (cachedPdfId > 0) {
                                record.pdf_id = cachedPdfId;
                            }
                        }
                        return record;
                    });
                    this.isLoading = false;
                },
                error: err => {
                    this.messageService.errorMessage('Dateien konnten nicht geladen werden', err);
                    this.isLoading = false;
                },
            });
        }
    }

    isLoadingOrSaving(): boolean {
        return this.isSaving || this.isLoading;
    }

    setCurrentUserAsTierarzt() {
        let tierarztId: number = this.localStorageService.getCurrentUser().tierarzt_id;
        this.ladeTierarzt(tierarztId);
        this.bsp.tierarzt_id = tierarztId;
    }

    ladeTierarzt(id: number) {
        if (!id) {
            id = this.localStorageService.getCurrentUser()?.tierarzt_id;
        }

        const params = new HttpParams().set('tierarzt_id', id);
        this.api.get(this.apiBaseUrl + 'tierarzt/read_one.php', params).subscribe({
            next: value => {
                this.currentVet = value;
                this.fc_tierarzt.setValue(this.currentVet);
            },
            error: err => {
                this.messageService.errorMessage('Tierarzt konnte nicht geladen werden!', err);
            },
        });
    }

    hasPermission(permissionId: number): boolean {
        return this.localStorageService.currentUserHasPermission(permissionId);
    }

    canEditPlan(): boolean {
        if (!this.hasPermission(11002)) {
            return false;
        }
        const statusId = this.bsp?.status_id;
        return statusId !== 232 && statusId !== 250 && statusId !== 251;
    }

    isReadOnly(): boolean {
        return !this.canEditPlan();
    }

    hasBerater(): boolean {
        return this.normalizeBeraterName(this.fc_v1_9_berater_name?.value) !== null;
    }

    private normalizeBeraterName(value: unknown): string | null {
        if (value === null || value === undefined) {
            return null;
        }
        const normalized = value.toString().trim();
        return normalized.length > 0 ? normalized : null;
    }

    private clearBeraterFields(): void {
        this.fc_beratungszeit_berater.setValue(null, { emitEvent: false });
        if (this.bsp) {
            this.bsp.berater_kuid = null;
            this.bsp.beratungszeit_berater_stunden = null;
        }
    }

    private syncReadOnlyFormControls(): void {
        const readOnly = this.isReadOnly();
        this.forEachFormControl(control => {
            if (readOnly) {
                control.disable({ emitEvent: false });
            } else {
                control.enable({ emitEvent: false });
            }
        });
    }

    private forEachFormControl(callback: (control: FormControl) => void): void {
        for (const key of Object.keys(this)) {
            const value = (this as Record<string, unknown>)[key];
            if (value instanceof FormControl) {
                callback(value);
            }
        }
    }

    setTierarzt(vet: Tierarzt) {
        if (!vet) {
            this.bsp.tierarzt_id = null;
        } else {
            this.bsp.tierarzt_id = vet.tierarzt_id;
        }
        this.saveBSP();
    }

    formHasNoFocus(): boolean {
        const active = document.activeElement;
        return !(
            (active && active.tagName === 'INPUT') ||
            active.tagName === 'TEXTAREA' ||
            active.tagName === 'SELECT'
        );
    }

    deleteTimeout() {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    saveBspTimeout() {
        if (this.isReadOnly()) {
            return;
        }
        this.deleteTimeout();
        this.timeout = setTimeout(() => {
            if (this.isSaving) {
                this.saveBspTimeout();
                return;
            }
            this.saveBSP(undefined, { silent: true });
        }, 1500);
    }

    @HostListener('input')
    @HostListener('change')
    onAutosaveInput(): void {
        this.saveBspTimeout();
    }

    saveBSP(
        datei?: BioSicherheitsPlanFile,
        options?: { statusIdForSave?: number; abschlussOnly?: boolean; silent?: boolean },
    ) {
        const isAbschluss = options?.abschlussOnly === true || options?.statusIdForSave === 232;
        if (this.isReadOnly() && !isAbschluss) {
            return;
        }
        this.deleteTimeout();

        // Update static FormControls with dynamic data before saving
        this.updateStaticFormControlsFromDynamic();

        this.prepareBspForSaving();

        if (options?.statusIdForSave != null) {
            this.bsp.status_id = options.statusIdForSave;
        } else if (!this.bsp.status_id) {
            this.bsp.status_id = 231;
        }
        if (!this.bsp.v1_1_datum) {
            this.bsp.v1_1_datum = new Date();
        }

        this.isSaving = true;
        this.api.post(this.apiBaseUrl + 'biosicherheitsplan_schwein/update.php', this.bsp).subscribe({
            next: response => {
                this.bsp = response;
                this.isSaving = false;
                this.syncReadOnlyFormControls();

                // Speichere dynamische Handlungsempfehlungen
                this.saveDynamicHandlungsempfehlungen();

                if (this.bsp.status_id === 232 || this.bsp.status_id === 251) {
                    this.syncReadOnlyFormControls();
                    this.showFinishedPdf(this.bsp);
                } else {
                    if (datei) {
                        this.saveNewFiles2(datei);
                    } else {
                        if (!options?.silent) {
                            this.initFormControls();
                        }
                        this.aktualisiereBrowserUrl();
                    }
                }

                if (!options?.silent) {
                    this.messageService.infoMessage('Biosicherheitsplan gespeichert!');
                }
            },
            error: error => {
                const previousStatus = this.bsp.status_id;
                this.isSaving = false;
                if (this.bsp?.bs_id) {
                    this.loadPlan(this.bsp.bs_id);
                } else if (previousStatus === 232) {
                    this.bsp.status_id = 231;
                }
                this.messageService.errorMessage('Fehler beim Speichern des Biosicherheitsplan!', error);
            },
        });
    }

    private updateStaticFormControlsFromDynamic(): void {
        // Update static FormControls with data from dynamic handlungsempfehlungen
        // Map all dynamic entries to their corresponding static FormControls
        const fieldMappings = [
            { dynamic: 0, static: 'fc_v126' },
            { dynamic: 1, static: 'fc_v127' },
            { dynamic: 2, static: 'fc_v128' },
            { dynamic: 3, static: 'fc_v129' },
            { dynamic: 4, static: 'fc_v130' },
            { dynamic: 5, static: 'fc_v131' },
            { dynamic: 6, static: 'fc_v132' },
        ];

        // Clear all static FormControls first
        fieldMappings.forEach(mapping => {
            this[`${mapping.static}_zu_nr`].setValue('');
            this[`${mapping.static}_erledigt`].setValue(false);
            this[`${mapping.static}_schwachstelle`].setValue('');
            this[`${mapping.static}_handlungsempfehlung`].setValue('');
            this[`${mapping.static}_unterlage`].setValue('');
        });

        // Set values from dynamic entries
        this.handlungsempfehlungen.forEach((handlungsempfehlung, index) => {
            if (index < fieldMappings.length) {
                const mapping = fieldMappings[index];
                this[`${mapping.static}_zu_nr`].setValue(handlungsempfehlung.zu_nr.value);
                this[`${mapping.static}_erledigt`].setValue(handlungsempfehlung.erledigt.value);
                this[`${mapping.static}_schwachstelle`].setValue(handlungsempfehlung.schwachstelle.value);
                this[`${mapping.static}_handlungsempfehlung`].setValue(handlungsempfehlung.handlungsempfehlung.value);
                this[`${mapping.static}_unterlage`].setValue(handlungsempfehlung.unterlage.value);
            }
        });
    }

    private saveDynamicHandlungsempfehlungen(): void {
        // This method is now redundant since updateStaticFormControlsFromDynamic handles the data mapping
        // The data is already saved in the main saveBSP call
        // Keeping this method for future use when we expand to support v127-v132
    }

    private prepareBspForSaving(): void {
        this.bsp.v1_1_datum = this.fc_v1_1_datum.value;
        this.bsp.v1_2_verantwortlich = this.fc_v1_2_verantwortlich.value;
        this.bsp.v1_3_verantwortlich_adresse = this.fc_v1_3_verantwortlich_adresse.value;
        this.bsp.v1_4_verantwortlich_telefon = this.fc_v1_4_verantwortlich_telefon.value;
        this.bsp.v1_6_verantwortlich_email = this.fc_v1_6_verantwortlich_email.value;
        this.bsp.v1_5_beihilfe_tsk = this.fc_v1_5_beihilfe_tsk.value;
        this.bsp.v1_7_steuer_optierend = this.fc_v1_7_steuer_optierend.value ? 1 : 0;
        this.bsp.v1_8_steuer_pauschal = this.fc_v1_8_steuer_pauschal.value ? 1 : 0;
        this.bsp.beratungszeit_tierarzt_stunden = this.fc_beratungszeit_tierarzt.value;
        const beraterName = this.normalizeBeraterName(this.fc_v1_9_berater_name.value);
        this.bsp.v1_9_berater_name = beraterName;
        if (beraterName) {
            this.bsp.beratungszeit_berater_stunden = this.fc_beratungszeit_berater.value;
        } else {
            this.bsp.beratungszeit_berater_stunden = null;
            this.bsp.berater_kuid = null;
        }
        this.bsp.v1_10_berater_adresse = this.fc_v1_10_berater_adresse.value;
        this.bsp.v1_11_berater_telefon = this.fc_v1_11_berater_telefon.value;
        this.bsp.v1_12_berater_email = this.fc_v1_12_berater_email.value;
        this.bsp.v1_13_standort_adresse = this.fc_v1_13_standort_adresse.value;
        this.bsp.v1_14_anzahl_staelle = this.fc_v1_14_anzahl_staelle.value;
        this.bsp.v1_15_stall_bezeichnungen = this.fc_v1_15_stall_bezeichnungen.value;
        this.bsp.v1_16_anzahl_sauenplaetze = this.fc_v1_16_anzahl_sauenplaetze.value;
        this.bsp.v1_17_anzahl_aufzuchtplaetze = this.fc_v1_17_anzahl_aufzuchtplaetze.value;
        this.bsp.v1_18_anzahl_mastplaetze = this.fc_v1_18_anzahl_mastplaetze.value;
        this.bsp.v1_19_mit_auslauf = this.fc_v1_19_mit_auslauf.value ? 1 : 0;
        this.bsp.v1_20_freiland = this.fc_v1_20_freiland.value ? 1 : 0;
        this.bsp.v1_21_stroh = this.fc_v1_21_stroh.value ? 1 : 0;
        this.bsp.v1_22_anlage = this.fc_v1_22_anlage.value;
        this.bsp.v1_23_aufstallung = this.fc_v1_23_aufstallung.value;
        this.bsp.v2_1_antwort = this.fc_v2_1_antwort?.value;
        this.bsp.v2_1_unterlage = this.fc_v2_1_unterlage?.value;
        this.bsp.v2_2_antwort = this.fc_v2_2_antwort?.value;
        this.bsp.v2_2_unterlage = this.fc_v2_2_unterlage?.value;
        this.bsp.v2_3_antwort = this.fc_v2_3_antwort?.value;
        this.bsp.v2_3_unterlage = this.fc_v2_3_unterlage?.value;
        this.bsp.v2_4_antwort = this.fc_v2_4_antwort?.value;
        this.bsp.v2_4_unterlage = this.fc_v2_4_unterlage?.value;
        this.bsp.v2_5_antwort = this.fc_v2_5_antwort?.value;
        this.bsp.v2_5_unterlage = this.fc_v2_5_unterlage?.value;
        this.bsp.v2_6_antwort = this.fc_v2_6_antwort?.value;
        this.bsp.v2_6_unterlage = this.fc_v2_6_unterlage?.value;
        this.bsp.v2_7_antwort = this.fc_v2_7_antwort?.value;
        this.bsp.v2_7_unterlage = this.fc_v2_7_unterlage?.value;
        this.bsp.v2_8_antwort = this.fc_v2_8_antwort?.value;
        this.bsp.v2_8_unterlage = this.fc_v2_8_unterlage?.value;
        this.bsp.v2_9_antwort = this.fc_v2_9_antwort?.value;
        this.bsp.v2_9_unterlage = this.fc_v2_9_unterlage?.value;
        this.bsp.v2_10_handlungsbedarf = this.fc_v2_10_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v2_10_antwort = this.fc_v2_10_antwort?.value;
        this.bsp.v2_10_unterlage = this.fc_v2_10_unterlage?.value;
        this.bsp.v2_11_handlungsbedarf = this.fc_v2_11_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v2_11_antwort = this.fc_v2_11_antwort?.value;
        this.bsp.v2_11_unterlage = this.fc_v2_11_unterlage?.value;
        this.bsp.v2_12_handlungsbedarf = this.fc_v2_12_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v2_12_antwort = this.fc_v2_12_antwort?.value;
        this.bsp.v2_12_unterlage = this.fc_v2_12_unterlage?.value;
        this.bsp.v3_13_unterlage = this.fc_v3_13_unterlage?.value;
        this.bsp.v3_14_unterlage = this.fc_v3_14_unterlage?.value;
        this.bsp.v3_15_antwort = this.fc_v3_15_antwort?.value;
        this.bsp.v3_15_unterlage = this.fc_v3_15_unterlage?.value;
        this.bsp.v3_16_antwort = this.fc_v3_16_antwort?.value;
        this.bsp.v3_16_unterlage_ein_und_ausgaenge = this.fc_v3_16_unterlage_ein_und_ausgaenge?.value ? 1 : 0;
        this.bsp.v3_16_unterlage_leicht_erreichbare_stellen = this.fc_v3_16_unterlage_leicht_erreichbare_stellen?.value
            ? 1
            : 0;
        this.bsp.v3_16_unterlage_sonstiges = this.fc_v3_16_unterlage_sonstiges?.value;
        this.bsp.v3_17_antwort = this.fc_v3_17_antwort?.value;
        this.bsp.v3_17_unterlage = this.fc_v3_17_unterlage?.value;
        this.bsp.v3_18_antwort = this.fc_v3_18_antwort?.value;
        this.bsp.v3_18_unterlage = this.fc_v3_18_unterlage?.value;
        this.bsp.v3_19_antwort = this.fc_v3_19_antwort?.value;
        this.bsp.v3_19_unterlage_im_weissbereich = this.fc_v3_19_unterlage_im_weissbereich?.value ? 1 : 0;
        this.bsp.v3_19_unterlage_im_schwarzbereich = this.fc_v3_19_unterlage_im_schwarzbereich?.value ? 1 : 0;
        this.bsp.v3_19_unterlage_sonstiges = this.fc_v3_19_unterlage_sonstiges?.value ? 1 : 0;
        this.bsp.v3_19_unterlage_sonstiges_text = this.fc_v3_19_unterlage_sonstiges_text?.value;
        this.bsp.v3_20_antwort = this.fc_v3_20_antwort?.value;
        this.bsp.v3_20_unterlage = this.fc_v3_20_unterlage?.value;
        this.bsp.v3_21_antwort = this.fc_v3_21_antwort?.value;
        this.bsp.v3_21_unterlage = this.fc_v3_21_unterlage?.value;
        this.bsp.v3_22_antwort = this.fc_v3_22_antwort?.value;
        this.bsp.v3_22_unterlage = this.fc_v3_22_unterlage?.value;
        this.bsp.v3_23_antwort = this.fc_v3_23_antwort?.value;
        this.bsp.v3_23_unterlage = this.fc_v3_23_unterlage?.value;
        this.bsp.v3_24_antwort = this.fc_v3_24_antwort?.value;
        this.bsp.v3_24_unterlage = this.fc_v3_24_unterlage?.value;
        this.bsp.v3_25_antwort = this.fc_v3_25_antwort?.value;
        this.bsp.v3_26_unterlage = this.fc_v3_26_unterlage?.value;
        this.bsp.v3_26_antwort = this.fc_v3_26_antwort?.value;
        this.bsp.v3_27_antwort = this.fc_v3_27_antwort?.value;
        this.bsp.v3_27_unterlage = this.fc_v3_27_unterlage?.value;
        this.bsp.v3_28_antwort = this.fc_v3_28_antwort?.value;
        this.bsp.v3_28_unterlage = this.fc_v3_28_unterlage?.value;
        // Punkte von tabelle 4
        this.prepareReinigungFormModels();

        this.bsp.v5_36_handlungsbedarf = this.fc_v5_36_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v5_36_antwort = this.fc_v5_36_antwort?.value;
        this.bsp.v5_36_unterlage = this.fc_v5_36_unterlage?.value;
        this.bsp.v5_37_handlungsbedarf = this.fc_v5_37_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v5_37_antwort = this.fc_v5_37_antwort?.value;
        this.bsp.v5_37_unterlage = this.fc_v5_37_unterlage?.value;
        this.bsp.v5_38_handlungsbedarf = this.fc_v5_38_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v5_38_antwort = this.fc_v5_38_antwort?.value;
        this.bsp.v5_38_unterlage = this.fc_v5_38_unterlage?.value;
        this.bsp.v5_39_handlungsbedarf = this.fc_v5_39_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v5_39_antwort = this.fc_v5_39_antwort?.value;
        this.bsp.v5_39_unterlage = this.fc_v5_39_unterlage?.value;
        this.bsp.v5_40_handlungsbedarf = this.fc_v5_40_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v5_40_antwort = this.fc_v5_40_antwort?.value;
        this.bsp.v5_40_unterlage = this.fc_v5_40_unterlage?.value;
        this.bsp.v5_41_handlungsbedarf = this.fc_v5_41_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v5_41_antwort = this.fc_v5_41_antwort?.value;
        this.bsp.v5_41_unterlage = this.fc_v5_41_unterlage?.value;
        this.bsp.v5_42_handlungsbedarf = this.fc_v5_42_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v5_42_antwort = this.fc_v5_42_antwort?.value;
        this.bsp.v5_42_unterlage = this.fc_v5_42_unterlage?.value;
        this.bsp.v5_43_vollstaendig = this.fc_v5_43_vollstaendig?.value ? 1 : 0;
        this.bsp.v5_43_restemast = this.fc_v5_43_restemast?.value ? 1 : 0;
        this.bsp.v5_43_abteilweise = this.fc_v5_43_abteilweise?.value ? 1 : 0;
        this.bsp.v5_43_antwort = this.fc_v5_43_antwort?.value;
        this.bsp.v5_43_unterlage = this.fc_v5_43_unterlage?.value;
        this.bsp.v5_44_kein_zukauf = this.fc_v5_44_kein_zukauf?.value ? 1 : 0;
        this.bsp.v5_44_eber = this.fc_v5_44_eber?.value ? 1 : 0;
        this.bsp.v5_44_jungsauen = this.fc_v5_44_jungsauen?.value ? 1 : 0;
        this.bsp.v5_44_sonstige = this.fc_v5_44_sonstige?.value ? 1 : 0;
        this.bsp.v5_44_antwort = this.fc_v5_44_antwort?.value;
        this.bsp.v5_44_unterlage = this.fc_v5_44_unterlage?.value;
        this.bsp.v5_45_antwort = this.fc_v5_45_antwort?.value;
        this.bsp.v5_45_unterlage = this.fc_v5_45_unterlage?.value;
        this.bsp.v5_46_antwort = this.fc_v5_46_antwort?.value;
        this.bsp.v5_46_unterlage = this.fc_v5_46_unterlage?.value;
        this.bsp.v5_47_antwort = this.fc_v5_47_antwort?.value;
        this.bsp.v5_47_unterlage = this.fc_v5_47_unterlage?.value;
        this.bsp.v6_48_handlungsbedarf = this.fc_v6_48_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v6_48_antwort = this.fc_v6_48_antwort?.value;
        this.bsp.v6_48_unterlage = this.fc_v6_48_unterlage?.value;
        this.bsp.v6_49_handlungsbedarf = this.fc_v6_49_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v6_49_antwort = this.fc_v6_49_antwort?.value;
        this.bsp.v6_49_unterlage = this.fc_v6_49_unterlage?.value;
        this.bsp.v6_50_handlungsbedarf = this.fc_v6_50_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v6_50_antwort = this.fc_v6_50_antwort?.value;
        this.bsp.v6_50_unterlage = this.fc_v6_50_unterlage?.value;
        this.bsp.v6_51_handlungsbedarf = this.fc_v6_51_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v6_51_antwort = this.fc_v6_51_antwort?.value;
        this.bsp.v6_51_unterlage = this.fc_v6_51_unterlage?.value;
        this.bsp.v6_52_handlungsbedarf = this.fc_v6_52_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v6_52_antwort = this.fc_v6_52_antwort?.value;
        this.bsp.v6_52_unterlage = this.fc_v6_52_unterlage?.value;
        this.bsp.v6_53_handlungsbedarf = this.fc_v6_53_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v6_53_antwort = this.fc_v6_53_antwort?.value;
        this.bsp.v6_53_unterlage = this.fc_v6_53_unterlage?.value;
        this.bsp.v6_54_handlungsbedarf = this.fc_v6_54_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v6_54_antwort = this.fc_v6_54_antwort?.value;
        this.bsp.v6_54_unterlage = this.fc_v6_54_unterlage?.value;
        this.bsp.v7_55_handlungsbedarf = this.fc_v7_55_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v7_55_einfriedung = this.fc_v7_55_einfriedung?.value ? 1 : 0;
        this.bsp.v7_55_tore = this.fc_v7_55_tore?.value ? 1 : 0;
        this.bsp.v7_55_beschilderung = this.fc_v7_55_beschilderung?.value ? 1 : 0;
        this.bsp.v7_55_auslauf = this.fc_v7_55_auslauf?.value ? 1 : 0;
        this.bsp.v7_55_sonstiges = this.fc_v7_55_sonstiges?.value ? 1 : 0;
        this.bsp.v7_55_antwort = this.fc_v7_55_antwort?.value;
        this.bsp.v7_55_unterlage = this.fc_v7_55_unterlage?.value;
        this.bsp.v7_56_handlungsbedarf = this.fc_v7_56_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v7_56_antwort = this.fc_v7_56_antwort?.value;
        this.bsp.v7_56_unterlage = this.fc_v7_56_unterlage?.value;
        this.bsp.v7_57_handlungsbedarf = this.fc_v7_57_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v7_57_antwort = this.fc_v7_57_antwort?.value;
        this.bsp.v7_57_unterlage = this.fc_v7_57_unterlage?.value;
        this.bsp.v7_58_handlungsbedarf = this.fc_v7_58_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v7_58_antwort = this.fc_v7_58_antwort?.value;
        this.bsp.v7_58_unterlage = this.fc_v7_58_unterlage?.value;
        this.bsp.v7_59_handlungsbedarf = this.fc_v7_59_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v7_59_antwort = this.fc_v7_59_antwort?.value;
        this.bsp.v7_59_unterlage = this.fc_v7_59_unterlage?.value;
        this.bsp.v8_60_antwort = this.fc_v8_60_antwort?.value;
        this.bsp.v8_60_unterlage = this.fc_v8_60_unterlage?.value;
        this.bsp.v8_61_antwort = this.fc_v8_61_antwort?.value;
        this.bsp.v8_61_unterlage = this.fc_v8_61_unterlage?.value;
        this.bsp.v8_62_antwort = this.fc_v8_62_antwort?.value;
        this.bsp.v8_62_unterlage = this.fc_v8_62_unterlage?.value;
        this.bsp.v8_63_antwort = this.fc_v8_63_antwort?.value;
        this.bsp.v8_63_unterlage = this.fc_v8_63_unterlage?.value;
        this.bsp.v8_64_antwort = this.fc_v8_64_antwort?.value;
        this.bsp.v8_64_unterlage = this.fc_v8_64_unterlage?.value;
        this.bsp.v8_65_antwort = this.fc_v8_65_antwort?.value;
        this.bsp.v8_65_unterlage = this.fc_v8_65_unterlage?.value;
        this.bsp.v8_66_antwort = this.fc_v8_66_antwort?.value;
        this.bsp.v8_66_unterlage = this.fc_v8_66_unterlage?.value;
        this.bsp.v8_67_antwort = this.fc_v8_67_antwort?.value;
        this.bsp.v8_67_unterlage = this.fc_v8_67_unterlage?.value;
        this.bsp.v8_68_antwort = this.fc_v8_68_antwort?.value;
        this.bsp.v8_68_unterlage = this.fc_v8_68_unterlage?.value;
        this.bsp.v8_69_antwort = this.fc_v8_69_antwort?.value;
        this.bsp.v8_69_unterlage = this.fc_v8_69_unterlage?.value;
        this.bsp.v8_70_antwort = this.fc_v8_70_antwort?.value;
        this.bsp.v8_70_unterlage = this.fc_v8_70_unterlage?.value;
        this.bsp.v8_71_antwort = this.fc_v8_71_antwort?.value;
        this.bsp.v8_71_unterlage = this.fc_v8_71_unterlage?.value;
        this.bsp.v8_72_antwort = this.fc_v8_72_antwort?.value;
        this.bsp.v8_72_unterlage = this.fc_v8_72_unterlage?.value;
        this.bsp.v8_73_handlungsbedarf = this.fc_v8_73_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_73_einfriedung = this.fc_v8_73_einfriedung?.value ? 1 : 0;
        this.bsp.v8_73_geschlossen = this.fc_v8_73_geschlossen?.value ? 1 : 0;
        this.bsp.v8_73_beschilderung = this.fc_v8_73_beschilderung?.value ? 1 : 0;
        this.bsp.v8_73_auslauf = this.fc_v8_73_auslauf?.value ? 1 : 0;
        this.bsp.v8_73_sonstiges = this.fc_v8_73_sonstiges?.value ? 1 : 0;
        this.bsp.v8_73_antwort = this.fc_v8_73_antwort?.value;
        this.bsp.v8_73_unterlage = this.fc_v8_73_unterlage?.value;
        this.bsp.v8_74_handlungsbedarf = this.fc_v8_74_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_74_antwort = this.fc_v8_74_antwort?.value;
        this.bsp.v8_74_unterlage = this.fc_v8_74_unterlage?.value;
        this.bsp.v8_75_handlungsbedarf = this.fc_v8_75_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_75_antwort = this.fc_v8_75_antwort?.value;
        this.bsp.v8_75_unterlage = this.fc_v8_75_unterlage?.value;
        this.bsp.v8_76_handlungsbedarf = this.fc_v8_76_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_76_antwort = this.fc_v8_76_antwort?.value;
        this.bsp.v8_76_unterlage = this.fc_v8_76_unterlage?.value;
        this.bsp.v8_77_handlungsbedarf = this.fc_v8_77_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_77_antwort = this.fc_v8_77_antwort?.value;
        this.bsp.v8_77_unterlage = this.fc_v8_77_unterlage?.value;
        this.bsp.v8_78_handlungsbedarf = this.fc_v8_78_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_78_antwort = this.fc_v8_78_antwort?.value;
        this.bsp.v8_78_unterlage = this.fc_v8_78_unterlage?.value;
        this.bsp.v8_79_handlungsbedarf = this.fc_v8_79_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_79_antwort = this.fc_v8_79_antwort?.value;
        this.bsp.v8_79_unterlage = this.fc_v8_79_unterlage?.value;
        this.bsp.v8_80_handlungsbedarf = this.fc_v8_80_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_80_antwort = this.fc_v8_80_antwort?.value;
        this.bsp.v8_80_unterlage = this.fc_v8_80_unterlage?.value;
        this.bsp.v8_81_handlungsbedarf = this.fc_v8_81_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_81_antwort = this.fc_v8_81_antwort?.value;
        this.bsp.v8_81_unterlage = this.fc_v8_81_unterlage?.value;
        this.bsp.v8_82_handlungsbedarf = this.fc_v8_82_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_82_antwort = this.fc_v8_82_antwort?.value;
        this.bsp.v8_82_unterlage = this.fc_v8_82_unterlage?.value;
        this.bsp.v8_83_handlungsbedarf = this.fc_v8_83_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_83_antwort = this.fc_v8_83_antwort?.value;
        this.bsp.v8_83_unterlage = this.fc_v8_83_unterlage?.value;
        this.bsp.v8_84_handlungsbedarf = this.fc_v8_84_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_84_antwort = this.fc_v8_84_antwort?.value;
        this.bsp.v8_84_unterlage = this.fc_v8_84_unterlage?.value;
        this.bsp.v8_85_handlungsbedarf = this.fc_v8_85_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_85_antwort = this.fc_v8_85_antwort?.value;
        this.bsp.v8_85_unterlage = this.fc_v8_85_unterlage?.value;
        this.bsp.v8_86_handlungsbedarf = this.fc_v8_86_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_86_antwort = this.fc_v8_86_antwort?.value;
        this.bsp.v8_86_unterlage = this.fc_v8_86_unterlage?.value;
        this.bsp.v8_87_handlungsbedarf = this.fc_v8_87_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_87_schleuse = this.fc_v8_87_schleuse?.value ? 1 : 0;
        this.bsp.v8_87_ort_schleuse = this.fc_v8_87_ort_schleuse?.value ? 1 : 0;
        this.bsp.v8_87_antwort = this.fc_v8_87_antwort?.value;
        this.bsp.v8_87_unterlage = this.fc_v8_87_unterlage?.value;
        this.bsp.v8_88_handlungsbedarf = this.fc_v8_88_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_88_antwort = this.fc_v8_88_antwort?.value;
        this.bsp.v8_88_unterlage = this.fc_v8_88_unterlage?.value;
        this.bsp.v8_89_handlungsbedarf = this.fc_v8_89_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v8_89_antwort = this.fc_v8_89_antwort?.value;
        this.bsp.v8_89_unterlage = this.fc_v8_89_unterlage?.value;
        this.bsp.v9_90_handlungsbedarf = this.fc_v9_90_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v9_90_antwort = this.fc_v9_90_antwort?.value;
        this.bsp.v9_90_unterlage = this.fc_v9_90_unterlage?.value;
        this.bsp.v9_91_handlungsbedarf = this.fc_v9_91_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v9_91_antwort = this.fc_v9_91_antwort?.value;
        this.bsp.v9_91_unterlage = this.fc_v9_91_unterlage?.value;
        this.bsp.v10_92_handlungsbedarf = this.fc_v10_92_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v10_92_bestandsregister = this.fc_v10_92_bestandsregister?.value ? 1 : 0;
        this.bsp.v10_92_berechnung_verluste = this.fc_v10_92_berechnung_verluste?.value ? 1 : 0;
        this.bsp.v10_92_sauenplaner = this.fc_v10_92_sauenplaner?.value ? 1 : 0;
        this.bsp.v10_92_mastplaner = this.fc_v10_92_mastplaner?.value ? 1 : 0;
        this.bsp.v10_92_nach_aufzeichnungen = this.fc_v10_92_nach_aufzeichnungen?.value ? 1 : 0;
        this.bsp.v10_92_antwort = this.fc_v10_92_antwort?.value;
        this.bsp.v10_92_unterlage = this.fc_v10_92_unterlage?.value;
        this.bsp.v10_93_handlungsbedarf = this.fc_v10_93_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v10_93_mindestens = this.fc_v10_93_mindestens?.value ? 1 : 0;
        this.bsp.v10_93_mit_hilfe = this.fc_v10_93_mit_hilfe?.value ? 1 : 0;
        this.bsp.v10_93_antwort = this.fc_v10_93_antwort?.value;
        this.bsp.v10_93_unterlage = this.fc_v10_93_unterlage?.value;
        this.bsp.v10_94_handlungsbedarf = this.fc_v10_94_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v10_94_antwort = this.fc_v10_94_antwort?.value;
        this.bsp.v10_94_unterlage = this.fc_v10_94_unterlage?.value;
        this.bsp.v10_95_handlungsbedarf = this.fc_v10_95_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v10_95_antwort = this.fc_v10_95_antwort?.value;
        this.bsp.v10_95_unterlage = this.fc_v10_95_unterlage?.value;
        this.bsp.v10_96_handlungsbedarf = this.fc_v10_96_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v10_96_antwort = this.fc_v10_96_antwort?.value;
        this.bsp.v10_96_unterlage = this.fc_v10_96_unterlage?.value;
        this.bsp.v10_97_handlungsbedarf = this.fc_v10_97_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v10_97_antwort = this.fc_v10_97_antwort?.value;
        this.bsp.v10_97_unterlage = this.fc_v10_97_unterlage?.value;
        this.bsp.v10_98_handlungsbedarf = this.fc_v10_98_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v10_98_antwort = this.fc_v10_98_antwort?.value;
        this.bsp.v10_98_unterlage = this.fc_v10_98_unterlage?.value;
        this.bsp.v10_99_handlungsbedarf = this.fc_v10_99_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v10_99_antwort = this.fc_v10_99_antwort?.value;
        this.bsp.v10_99_unterlage = this.fc_v10_99_unterlage?.value;
        this.bsp.v11_100_handlungsbedarf = this.fc_v11_100_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v11_100_mastbetrieb = this.fc_v11_100_mastbetrieb?.value ? 1 : 0;
        this.bsp.v11_100_zusammenschluss = this.fc_v11_100_zusammenschluss?.value ? 1 : 0;
        this.bsp.v11_100_ab_stall = this.fc_v11_100_ab_stall?.value ? 1 : 0;
        this.bsp.v11_100_antwort = this.fc_v11_100_antwort?.value;
        this.bsp.v11_100_unterlage = this.fc_v11_100_unterlage?.value;
        this.bsp.v11_101_handlungsbedarf = this.fc_v11_101_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v11_101_antwort = this.fc_v11_101_antwort?.value;
        this.bsp.v11_101_unterlage = this.fc_v11_101_unterlage?.value;
        this.bsp.v11_102_handlungsbedarf = this.fc_v11_102_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v11_102_antwort = this.fc_v11_102_antwort?.value;
        this.bsp.v11_102_unterlage = this.fc_v11_102_unterlage?.value;
        this.bsp.v11_103_handlungsbedarf = this.fc_v11_103_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v11_103_antwort = this.fc_v11_103_antwort?.value;
        this.bsp.v11_103_unterlage = this.fc_v11_103_unterlage?.value;
        this.bsp.v11_104_handlungsbedarf = this.fc_v11_104_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v11_104_antwort = this.fc_v11_104_antwort?.value;
        this.bsp.v11_104_unterlage = this.fc_v11_104_unterlage?.value;
        this.bsp.v11_105_handlungsbedarf = this.fc_v11_105_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v11_105_antwort = this.fc_v11_105_antwort?.value;
        this.bsp.v11_105_unterlage = this.fc_v11_105_unterlage?.value;
        this.bsp.v11_106_handlungsbedarf = this.fc_v11_106_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v11_106_antwort = this.fc_v11_106_antwort?.value;
        this.bsp.v11_106_unterlage = this.fc_v11_106_unterlage?.value;
        this.bsp.v11_107_handlungsbedarf = this.fc_v11_107_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v11_107_antwort = this.fc_v11_107_antwort?.value;
        this.bsp.v11_107_unterlage = this.fc_v11_107_unterlage?.value;
        this.bsp.v11_108_handlungsbedarf = this.fc_v11_108_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v11_108_antwort = this.fc_v11_108_antwort?.value;
        this.bsp.v11_108_unterlage = this.fc_v11_108_unterlage?.value;
        this.bsp.v11_109_handlungsbedarf = this.fc_v11_109_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v11_109_antwort = this.fc_v11_109_antwort?.value;
        this.bsp.v11_109_unterlage = this.fc_v11_109_unterlage?.value;
        this.bsp.v12_110_handlungsbedarf = this.fc_v12_110_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v12_110_antwort = this.fc_v12_110_antwort?.value;
        this.bsp.v12_110_unterlage = this.fc_v12_110_unterlage?.value;
        this.bsp.v12_111_handlungsbedarf = this.fc_v12_111_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v12_111_antwort = this.fc_v12_111_antwort?.value;
        this.bsp.v12_111_unterlage = this.fc_v12_111_unterlage?.value;
        this.bsp.v12_112_handlungsbedarf = this.fc_v12_112_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v12_112_antwort = this.fc_v12_112_antwort?.value;
        this.bsp.v12_112_unterlage = this.fc_v12_112_unterlage?.value;
        this.bsp.v12_113_handlungsbedarf = this.fc_v12_113_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v12_113_antwort = this.fc_v12_113_antwort?.value;
        this.bsp.v12_113_unterlage = this.fc_v12_113_unterlage?.value;
        this.bsp.v12_114_handlungsbedarf = this.fc_v12_114_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v12_114_antwort = this.fc_v12_114_antwort?.value;
        this.bsp.v12_114_unterlage = this.fc_v12_114_unterlage?.value;
        this.bsp.v13_115_handlungsbedarf = this.fc_v13_115_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v13_115_antwort = this.fc_v13_115_antwort?.value;
        this.bsp.v13_115_unterlage = this.fc_v13_115_unterlage?.value;
        this.bsp.v13_116_handlungsbedarf = this.fc_v13_116_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v13_116_antwort = this.fc_v13_116_antwort?.value;
        this.bsp.v13_116_unterlage = this.fc_v13_116_unterlage?.value;
        this.bsp.v13_117_handlungsbedarf = this.fc_v13_117_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v13_117_antwort = this.fc_v13_117_antwort?.value;
        this.bsp.v13_117_unterlage = this.fc_v13_117_unterlage?.value;
        this.bsp.v13_118_handlungsbedarf = this.fc_v13_118_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v13_118_antwort = this.fc_v13_118_antwort?.value;
        this.bsp.v13_118_unterlage = this.fc_v13_118_unterlage?.value;
        this.bsp.v13_119_handlungsbedarf = this.fc_v13_119_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v13_119_antwort = this.fc_v13_119_antwort?.value;
        this.bsp.v13_119_unterlage = this.fc_v13_119_unterlage?.value;
        this.bsp.v14_120_handlungsbedarf = this.fc_v14_120_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v14_120_antwort = this.fc_v14_120_antwort?.value;
        this.bsp.v14_120_unterlage = this.fc_v14_120_unterlage?.value;
        this.bsp.v14_121_handlungsbedarf = this.fc_v14_121_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v14_121_antwort = this.fc_v14_121_antwort?.value;
        this.bsp.v14_121_unterlage = this.fc_v14_121_unterlage?.value;
        this.bsp.v14_122_handlungsbedarf = this.fc_v14_122_handlungsbedarf?.value ? 1 : 0;
        this.bsp.v14_122_antwort = this.fc_v14_122_antwort?.value;
        this.bsp.v14_122_unterlage = this.fc_v14_122_unterlage?.value;

        // Frage 123
        this.bsp.v123_zu_nr = this.fc_v123_zu_nr.value;
        this.bsp.v123_erledigt = this.fc_v123_erledigt.value ? 1 : 0;
        this.bsp.v123_schwachstelle = this.fc_v123_schwachstelle.value;
        this.bsp.v123_handlungsempfehlung = this.fc_v123_handlungsempfehlung.value;
        this.bsp.v123_unterlage = this.fc_v123_unterlage.value;

        // Frage 124
        this.bsp.v124_zu_nr = this.fc_v124_zu_nr.value;
        this.bsp.v124_erledigt = this.fc_v124_erledigt.value ? 1 : 0;
        this.bsp.v124_schwachstelle = this.fc_v124_schwachstelle.value;
        this.bsp.v124_handlungsempfehlung = this.fc_v124_handlungsempfehlung.value;
        this.bsp.v124_unterlage = this.fc_v124_unterlage.value;

        // Frage 125
        this.bsp.v125_zu_nr = this.fc_v125_zu_nr.value;
        this.bsp.v125_erledigt = this.fc_v125_erledigt.value ? 1 : 0;
        this.bsp.v125_schwachstelle = this.fc_v125_schwachstelle.value;
        this.bsp.v125_handlungsempfehlung = this.fc_v125_handlungsempfehlung.value;
        this.bsp.v125_unterlage = this.fc_v125_unterlage.value;

        // Zusätzliche Handlungsempfehlungen (dynamisch)
        this.bsp.v126_zu_nr = this.fc_v126_zu_nr.value;
        this.bsp.v126_erledigt = this.fc_v126_erledigt.value ? 1 : 0;
        this.bsp.v126_schwachstelle = this.fc_v126_schwachstelle.value;
        this.bsp.v126_handlungsempfehlung = this.fc_v126_handlungsempfehlung.value;
        this.bsp.v126_unterlage = this.fc_v126_unterlage.value;

        // Zusätzliche Handlungsempfehlungen v127-v132
        this.bsp.v127_zu_nr = this.fc_v127_zu_nr.value;
        this.bsp.v127_erledigt = this.fc_v127_erledigt.value ? 1 : 0;
        this.bsp.v127_schwachstelle = this.fc_v127_schwachstelle.value;
        this.bsp.v127_handlungsempfehlung = this.fc_v127_handlungsempfehlung.value;
        this.bsp.v127_unterlage = this.fc_v127_unterlage.value;

        this.bsp.v128_zu_nr = this.fc_v128_zu_nr.value;
        this.bsp.v128_erledigt = this.fc_v128_erledigt.value ? 1 : 0;
        this.bsp.v128_schwachstelle = this.fc_v128_schwachstelle.value;
        this.bsp.v128_handlungsempfehlung = this.fc_v128_handlungsempfehlung.value;
        this.bsp.v128_unterlage = this.fc_v128_unterlage.value;

        this.bsp.v129_zu_nr = this.fc_v129_zu_nr.value;
        this.bsp.v129_erledigt = this.fc_v129_erledigt.value ? 1 : 0;
        this.bsp.v129_schwachstelle = this.fc_v129_schwachstelle.value;
        this.bsp.v129_handlungsempfehlung = this.fc_v129_handlungsempfehlung.value;
        this.bsp.v129_unterlage = this.fc_v129_unterlage.value;

        this.bsp.v130_zu_nr = this.fc_v130_zu_nr.value;
        this.bsp.v130_erledigt = this.fc_v130_erledigt.value ? 1 : 0;
        this.bsp.v130_schwachstelle = this.fc_v130_schwachstelle.value;
        this.bsp.v130_handlungsempfehlung = this.fc_v130_handlungsempfehlung.value;
        this.bsp.v130_unterlage = this.fc_v130_unterlage.value;

        this.bsp.v131_zu_nr = this.fc_v131_zu_nr.value;
        this.bsp.v131_erledigt = this.fc_v131_erledigt.value ? 1 : 0;
        this.bsp.v131_schwachstelle = this.fc_v131_schwachstelle.value;
        this.bsp.v131_handlungsempfehlung = this.fc_v131_handlungsempfehlung.value;
        this.bsp.v131_unterlage = this.fc_v131_unterlage.value;

        this.bsp.v132_zu_nr = this.fc_v132_zu_nr.value;
        this.bsp.v132_erledigt = this.fc_v132_erledigt.value ? 1 : 0;
        this.bsp.v132_schwachstelle = this.fc_v132_schwachstelle.value;
        this.bsp.v132_handlungsempfehlung = this.fc_v132_handlungsempfehlung.value;
        this.bsp.v132_unterlage = this.fc_v132_unterlage.value;
    }

    showFinishedPdf(selectedBsp: BioSicherheitPlanSchwein) {
        const titel = 'Bio-Sicherheitsplan ' + selectedBsp?.bs_id;
        const input = new PdfViewerDialogInput(
            'biosicherheitsplan_schwein/read_or_mail_pdf.php',
            new HttpParams().set('bs_id', selectedBsp?.bs_id),
            titel,
            {
                email: { sende_mail: true, kunde_id: selectedBsp?.kunde_id },
                targetRoute: ['/belege', 'bestandsbesuch'],
                targetQueryParams: { tab: 'biosicherheitsplan-schwein' },
            },
        );
        this.pdf.openPdfViewer(input);
    }

    addReinigung() {
        const controls: Reinigungseintrag = new Reinigungseintrag();
        controls.id = this.reinigungsplaene.length;
        controls.bsr_id = this.bsp?.bs_id;
        controls.fc_stall = new FormControl('');
        for (let i = 0; i < Reinigungseintrag.CONTROL_LENGTH; i++) {
            const control = new ReinigungFormControls(
                0, // handlungsbedarf
                undefined, // antwort
                undefined, // unterlage
                undefined, // massnahmen
            );
            controls.formControls.push(control);
        }
        this.reinigungsplaene.push(controls);
    }

    removeReinigung(plan: Reinigungseintrag): void {
        const input = new ConfirmDialogInput();
        input.headline = 'Reinigungsplan löschen';
        input.text = 'Möchten Sie diesen Eintrag wirklich löschen?';
        input.okButton = 'Ja';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe((result: ConfirmDialogResult) => {
                if (result?.ok && result?.confirmed) {
                    const idx = this.reinigungsplaene.findIndex(r => r.bsr_id === plan.bsr_id);

                    if (idx === -1) {
                        return;
                    }
                    const payload = { bsr_id: plan.bsr_id };
                    this.api
                        .deleteGeneric(this.apiBaseUrl + 'biosicherheitsplan_schwein/delete_reinigung.php', payload)
                        .subscribe({
                            next: () => {
                                this.messageService.infoMessage('Reinigungseintrag erfolgreich gelöscht.');
                                this.loadPlan(this.bsp.bs_id);
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler beim Löschen des Reinigungseintrags: ', err);
                            },
                        });
                }
            });

        // this.reinigungsplaene.splice(idx, 1);
        // // this.bsp.reinigungen komplett neu befüllen
        // this.bsp.reinigungen = [];
        // this.bsp.reinigungen = this.reinigungsplaene.map((p) => {
        //     return {
        //         bsr_id: p.bsr_id,
        //         bs_id: this.bsp.bs_id,
        //         stall: p.fc_stall.value,
        //
        //         v4_29_handlungsbedarf: p.formControls[0].handlungsbedarf.value ? 1 : 0,
        //         v4_29_antwort: p.formControls[0].antwort.value,
        //         v4_29_unterlage: p.formControls[0].unterlage.value,
        //         v4_30_handlungsbedarf: p.formControls[1].handlungsbedarf.value ? 1 : 0,
        //         v4_30_antwort: p.formControls[1].antwort.value,
        //         v4_30_unterlage: p.formControls[1].unterlage.value,
        //         v4_31_handlungsbedarf: p.formControls[2].handlungsbedarf.value ? 1 : 0,
        //         v4_31_antwort: p.formControls[2].antwort.value,
        //         v4_31_unterlage: p.formControls[2].unterlage.value,
        //         v4_32_handlungsbedarf: p.formControls[3].handlungsbedarf.value ? 1 : 0,
        //         v4_32_antwort: p.formControls[3].antwort.value,
        //         v4_32_unterlage: p.formControls[3].unterlage.value,
        //         v4_33_handlungsbedarf: p.formControls[4].handlungsbedarf.value ? 1 : 0,
        //         v4_33_antwort: p.formControls[4].antwort.value,
        //         v4_33_unterlage: p.formControls[4].unterlage.value,
        //         v4_34_handlungsbedarf: p.formControls[5].handlungsbedarf.value ? 1 : 0,
        //         v4_34_antwort: p.formControls[5].antwort.value,
        //         v4_34_unterlage: p.formControls[5].unterlage.value,
        //         v4_35_handlungsbedarf: p.formControls[6].handlungsbedarf.value ? 1 : 0,
        //         v4_35_antwort: p.formControls[6].antwort.value,
        //         v4_35_unterlage: p.formControls[6].unterlage.value,
        //         v4_35_massnahmen: p.formControls[6].massnahmen?.value,
        //     } as BioSicherheitPlanSchweinReinigung;
        // });
        // this.saveBSP();
    }

    private aktualisiereBrowserUrl() {
        const url = this.router.createUrlTree(['/belege/biosicherheitsplanschwein/' + this.bsp?.bs_id]).toString();

        window.history.replaceState({}, '', url);
    }

    private initFormControls() {
        this.fc_v1_1_datum.setValue(this.bsp?.v1_1_datum);
        this.fc_v1_2_verantwortlich.setValue(this.bsp?.v1_2_verantwortlich);
        this.fc_v1_3_verantwortlich_adresse.setValue(this.bsp?.v1_3_verantwortlich_adresse);
        this.fc_v1_4_verantwortlich_telefon.setValue(this.bsp?.v1_4_verantwortlich_telefon);
        this.fc_v1_6_verantwortlich_email.setValue(this.bsp?.v1_6_verantwortlich_email);
        this.fc_v1_5_beihilfe_tsk.setValue(this.bsp?.v1_5_beihilfe_tsk);
        this.fc_v1_7_steuer_optierend.setValue(this.bsp?.v1_7_steuer_optierend);
        this.fc_v1_8_steuer_pauschal.setValue(this.bsp?.v1_8_steuer_pauschal);
        this.fc_beratungszeit_tierarzt.setValue(this.bsp?.beratungszeit_tierarzt_stunden ?? null);
        this.fc_v1_9_berater_name.setValue(this.bsp?.v1_9_berater_name ?? null);
        if (this.hasBerater()) {
            this.fc_beratungszeit_berater.setValue(this.bsp?.beratungszeit_berater_stunden ?? null);
        } else {
            this.clearBeraterFields();
        }
        this.fc_v1_10_berater_adresse.setValue(this.bsp?.v1_10_berater_adresse);
        this.fc_v1_11_berater_telefon.setValue(this.bsp?.v1_11_berater_telefon);
        this.fc_v1_12_berater_email.setValue(this.bsp?.v1_12_berater_email);
        this.setLieferadresse();
        this.fc_v1_13_standort_adresse.setValue(this.bsp?.v1_13_standort_adresse);
        this.fc_v1_14_anzahl_staelle.setValue(this.bsp?.v1_14_anzahl_staelle);
        this.fc_v1_15_stall_bezeichnungen.setValue(this.bsp?.v1_15_stall_bezeichnungen);
        this.fc_v1_16_anzahl_sauenplaetze.setValue(this.bsp?.v1_16_anzahl_sauenplaetze);
        this.fc_v1_17_anzahl_aufzuchtplaetze.setValue(this.bsp?.v1_17_anzahl_aufzuchtplaetze);
        this.fc_v1_18_anzahl_mastplaetze.setValue(this.bsp?.v1_18_anzahl_mastplaetze);
        this.fc_v1_19_mit_auslauf.setValue(this.bsp?.v1_19_mit_auslauf);
        this.fc_v1_20_freiland.setValue(this.bsp?.v1_20_freiland);
        this.fc_v1_21_stroh.setValue(this.bsp?.v1_21_stroh);
        this.fc_v1_23_aufstallung.setValue(this.bsp?.v1_23_aufstallung);
        this.fc_v1_22_anlage.setValue(this.bsp?.v1_22_anlage);
        this.fc_v2_1_antwort.setValue(this.bsp?.v2_1_antwort);
        this.fc_v2_1_unterlage.setValue(this.bsp?.v2_1_unterlage);
        this.fc_v2_2_antwort.setValue(this.bsp?.v2_2_antwort);
        this.fc_v2_2_unterlage.setValue(this.bsp?.v2_2_unterlage);
        this.fc_v2_3_antwort.setValue(this.bsp?.v2_3_antwort);
        this.fc_v2_3_unterlage.setValue(this.bsp?.v2_3_unterlage);
        this.fc_v2_4_antwort.setValue(this.bsp?.v2_4_antwort);
        this.fc_v2_4_unterlage.setValue(this.bsp?.v2_4_unterlage);
        this.fc_v2_5_antwort.setValue(this.bsp?.v2_5_antwort);
        this.fc_v2_5_unterlage.setValue(this.bsp?.v2_5_unterlage);
        this.fc_v2_6_antwort.setValue(this.bsp?.v2_6_antwort);
        this.fc_v2_6_unterlage.setValue(this.bsp?.v2_6_unterlage);
        this.fc_v2_7_antwort.setValue(this.bsp?.v2_7_antwort);
        this.fc_v2_7_unterlage.setValue(this.bsp?.v2_7_unterlage);
        this.fc_v2_8_antwort.setValue(this.bsp?.v2_8_antwort);
        this.fc_v2_8_unterlage.setValue(this.bsp?.v2_8_unterlage);
        this.fc_v2_9_antwort.setValue(this.bsp?.v2_9_antwort);
        this.fc_v2_9_unterlage.setValue(this.bsp?.v2_9_unterlage);
        this.fc_v2_10_handlungsbedarf.setValue(this.bsp?.v2_10_handlungsbedarf);
        this.fc_v2_10_antwort.setValue(this.bsp?.v2_10_antwort);
        this.fc_v2_10_unterlage.setValue(this.bsp?.v2_10_unterlage);
        this.fc_v2_11_handlungsbedarf.setValue(this.bsp?.v2_11_handlungsbedarf);
        this.fc_v2_11_antwort.setValue(this.bsp?.v2_11_antwort);
        this.fc_v2_11_unterlage.setValue(this.bsp?.v2_11_unterlage);
        this.fc_v2_12_handlungsbedarf.setValue(this.bsp?.v2_12_handlungsbedarf);
        this.fc_v2_12_antwort.setValue(this.bsp?.v2_12_antwort);
        this.fc_v2_12_unterlage.setValue(this.bsp?.v2_12_unterlage);
        this.fc_v3_13_unterlage.setValue(this.bsp?.v3_13_unterlage);
        this.fc_v3_14_unterlage.setValue(this.bsp?.v3_14_unterlage);
        this.fc_v3_15_antwort.setValue(this.bsp?.v3_15_antwort);
        this.fc_v3_15_unterlage.setValue(this.bsp?.v3_15_unterlage);
        this.fc_v3_16_antwort.setValue(this.bsp?.v3_16_antwort);
        this.fc_v3_16_unterlage_ein_und_ausgaenge.setValue(this.bsp?.v3_16_unterlage_ein_und_ausgaenge);
        this.fc_v3_16_unterlage_leicht_erreichbare_stellen.setValue(
            this.bsp?.v3_16_unterlage_leicht_erreichbare_stellen,
        );
        this.fc_v3_16_unterlage_sonstiges.setValue(this.bsp?.v3_16_unterlage_sonstiges);
        this.fc_v3_17_antwort.setValue(this.bsp?.v3_17_antwort);
        this.fc_v3_17_unterlage.setValue(this.bsp?.v3_17_unterlage);
        this.fc_v3_18_antwort.setValue(this.bsp?.v3_18_antwort);
        this.fc_v3_18_unterlage.setValue(this.bsp?.v3_18_unterlage);
        this.fc_v3_19_antwort.setValue(this.bsp?.v3_19_antwort);
        this.fc_v3_19_unterlage_im_weissbereich.setValue(this.bsp?.v3_19_unterlage_im_weissbereich);
        this.fc_v3_19_unterlage_im_schwarzbereich.setValue(this.bsp?.v3_19_unterlage_im_schwarzbereich);
        this.fc_v3_19_unterlage_sonstiges.setValue(this.bsp?.v3_19_unterlage_sonstiges);
        this.fc_v3_19_unterlage_sonstiges_text.setValue(this.bsp?.v3_19_unterlage_sonstiges_text);
        this.fc_v3_20_antwort.setValue(this.bsp?.v3_20_antwort);
        this.fc_v3_20_unterlage.setValue(this.bsp?.v3_20_unterlage);
        this.fc_v3_21_unterlage.setValue(this.bsp?.v3_21_unterlage);
        this.fc_v3_21_antwort.setValue(this.bsp?.v3_21_antwort);
        this.fc_v3_22_antwort.setValue(this.bsp?.v3_22_antwort);
        this.fc_v3_22_unterlage.setValue(this.bsp?.v3_22_unterlage);
        this.fc_v3_23_antwort.setValue(this.bsp?.v3_23_antwort);
        this.fc_v3_23_unterlage.setValue(this.bsp?.v3_23_unterlage);
        this.fc_v3_24_antwort.setValue(this.bsp?.v3_24_antwort);
        this.fc_v3_24_unterlage.setValue(this.bsp?.v3_24_unterlage);
        this.fc_v3_25_antwort.setValue(this.bsp?.v3_25_antwort);
        this.fc_v3_26_antwort.setValue(this.bsp?.v3_26_antwort);
        this.fc_v3_26_unterlage.setValue(this.bsp?.v3_26_unterlage);
        this.fc_v3_27_antwort.setValue(this.bsp?.v3_27_antwort);
        this.fc_v3_27_unterlage.setValue(this.bsp?.v3_27_unterlage);
        this.fc_v3_28_antwort.setValue(this.bsp?.v3_28_antwort);
        this.fc_v3_28_unterlage.setValue(this.bsp?.v3_28_unterlage);

        this.loadReinigungFromModel();

        this.fc_v5_36_handlungsbedarf.setValue(this.bsp?.v5_36_handlungsbedarf);
        this.fc_v5_36_antwort.setValue(this.bsp?.v5_36_antwort);
        this.fc_v5_36_unterlage.setValue(this.bsp?.v5_36_unterlage);
        this.fc_v5_37_handlungsbedarf.setValue(this.bsp?.v5_37_handlungsbedarf);
        this.fc_v5_37_antwort.setValue(this.bsp?.v5_37_antwort);
        this.fc_v5_37_unterlage.setValue(this.bsp?.v5_37_unterlage);
        this.fc_v5_38_handlungsbedarf.setValue(this.bsp?.v5_38_handlungsbedarf);
        this.fc_v5_38_antwort.setValue(this.bsp?.v5_38_antwort);
        this.fc_v5_38_unterlage.setValue(this.bsp?.v5_38_unterlage);
        this.fc_v5_39_handlungsbedarf.setValue(this.bsp?.v5_39_handlungsbedarf);
        this.fc_v5_39_antwort.setValue(this.bsp?.v5_39_antwort);
        this.fc_v5_39_unterlage.setValue(this.bsp?.v5_39_unterlage);
        this.fc_v5_40_handlungsbedarf.setValue(this.bsp?.v5_40_handlungsbedarf);
        this.fc_v5_40_antwort.setValue(this.bsp?.v5_40_antwort);
        this.fc_v5_40_unterlage.setValue(this.bsp?.v5_40_unterlage);
        this.fc_v5_41_handlungsbedarf.setValue(this.bsp?.v5_41_handlungsbedarf);
        this.fc_v5_41_antwort.setValue(this.bsp?.v5_41_antwort);
        this.fc_v5_41_unterlage.setValue(this.bsp?.v5_41_unterlage);
        this.fc_v5_42_handlungsbedarf.setValue(this.bsp?.v5_42_handlungsbedarf);
        this.fc_v5_42_antwort.setValue(this.bsp?.v5_42_antwort);
        this.fc_v5_42_unterlage.setValue(this.bsp?.v5_42_unterlage);
        this.fc_v5_43_vollstaendig.setValue(this.bsp?.v5_43_vollstaendig);
        this.fc_v5_43_restemast.setValue(this.bsp?.v5_43_restemast);
        this.fc_v5_43_abteilweise.setValue(this.bsp?.v5_43_abteilweise);
        this.fc_v5_43_antwort.setValue(this.bsp?.v5_43_antwort);
        this.fc_v5_43_unterlage.setValue(this.bsp?.v5_43_unterlage);
        this.fc_v5_44_kein_zukauf.setValue(this.bsp?.v5_44_kein_zukauf);
        this.fc_v5_44_eber.setValue(this.bsp?.v5_44_eber);
        this.fc_v5_44_jungsauen.setValue(this.bsp?.v5_44_jungsauen);
        this.fc_v5_44_sonstige.setValue(this.bsp?.v5_44_sonstige);
        this.fc_v5_44_antwort.setValue(this.bsp?.v5_44_antwort);
        this.fc_v5_44_unterlage.setValue(this.bsp?.v5_44_unterlage);
        this.fc_v5_45_antwort.setValue(this.bsp?.v5_45_antwort);
        this.fc_v5_45_unterlage.setValue(this.bsp?.v5_45_unterlage);
        this.fc_v5_46_antwort.setValue(this.bsp?.v5_46_antwort);
        this.fc_v5_46_unterlage.setValue(this.bsp?.v5_46_unterlage);
        this.fc_v5_47_antwort.setValue(this.bsp?.v5_47_antwort);
        this.fc_v5_47_unterlage.setValue(this.bsp?.v5_47_unterlage);
        this.fc_v6_48_handlungsbedarf.setValue(this.bsp?.v6_48_handlungsbedarf);
        this.fc_v6_48_antwort.setValue(this.bsp?.v6_48_antwort);
        this.fc_v6_48_unterlage.setValue(this.bsp?.v6_48_unterlage);
        this.fc_v6_49_handlungsbedarf.setValue(this.bsp?.v6_49_handlungsbedarf);
        this.fc_v6_49_antwort.setValue(this.bsp?.v6_49_antwort);
        this.fc_v6_49_unterlage.setValue(this.bsp?.v6_49_unterlage);
        this.fc_v6_50_handlungsbedarf.setValue(this.bsp?.v6_50_handlungsbedarf);
        this.fc_v6_50_antwort.setValue(this.bsp?.v6_50_antwort);
        this.fc_v6_50_unterlage.setValue(this.bsp?.v6_50_unterlage);
        this.fc_v6_51_handlungsbedarf.setValue(this.bsp?.v6_51_handlungsbedarf);
        this.fc_v6_51_antwort.setValue(this.bsp?.v6_51_antwort);
        this.fc_v6_51_unterlage.setValue(this.bsp?.v6_51_unterlage);
        this.fc_v6_52_handlungsbedarf.setValue(this.bsp?.v6_52_handlungsbedarf);
        this.fc_v6_52_antwort.setValue(this.bsp?.v6_52_antwort);
        this.fc_v6_52_unterlage.setValue(this.bsp?.v6_52_unterlage);
        this.fc_v6_53_handlungsbedarf.setValue(this.bsp?.v6_53_handlungsbedarf);
        this.fc_v6_53_antwort.setValue(this.bsp?.v6_53_antwort);
        this.fc_v6_53_unterlage.setValue(this.bsp?.v6_53_unterlage);
        this.fc_v6_54_handlungsbedarf.setValue(this.bsp?.v6_54_handlungsbedarf);
        this.fc_v6_54_antwort.setValue(this.bsp?.v6_54_antwort);
        this.fc_v6_54_unterlage.setValue(this.bsp?.v6_54_unterlage);
        this.fc_v7_55_handlungsbedarf.setValue(this.bsp?.v7_55_handlungsbedarf);
        this.fc_v7_55_einfriedung.setValue(this.bsp?.v7_55_einfriedung);
        this.fc_v7_55_tore.setValue(this.bsp?.v7_55_tore);
        this.fc_v7_55_beschilderung.setValue(this.bsp?.v7_55_beschilderung);
        this.fc_v7_55_auslauf.setValue(this.bsp?.v7_55_auslauf);
        this.fc_v7_55_sonstiges.setValue(this.bsp?.v7_55_sonstiges);
        this.fc_v7_55_antwort.setValue(this.bsp?.v7_55_antwort);
        this.fc_v7_55_unterlage.setValue(this.bsp?.v7_55_unterlage);
        this.fc_v7_56_handlungsbedarf.setValue(this.bsp?.v7_56_handlungsbedarf);
        this.fc_v7_56_antwort.setValue(this.bsp?.v7_56_antwort);
        this.fc_v7_56_unterlage.setValue(this.bsp?.v7_56_unterlage);
        this.fc_v7_57_handlungsbedarf.setValue(this.bsp?.v7_57_handlungsbedarf);
        this.fc_v7_57_antwort.setValue(this.bsp?.v7_57_antwort);
        this.fc_v7_57_unterlage.setValue(this.bsp?.v7_57_unterlage);
        this.fc_v7_58_handlungsbedarf.setValue(this.bsp?.v7_58_handlungsbedarf);
        this.fc_v7_58_antwort.setValue(this.bsp?.v7_58_antwort);
        this.fc_v7_58_unterlage.setValue(this.bsp?.v7_58_unterlage);
        this.fc_v7_59_handlungsbedarf.setValue(this.bsp?.v7_59_handlungsbedarf);
        this.fc_v7_59_antwort.setValue(this.bsp?.v7_59_antwort);
        this.fc_v7_59_unterlage.setValue(this.bsp?.v7_59_unterlage);
        this.fc_v8_60_antwort.setValue(this.bsp?.v8_60_antwort);
        this.fc_v8_60_unterlage.setValue(this.bsp?.v8_60_unterlage);
        this.fc_v8_61_antwort.setValue(this.bsp?.v8_61_antwort);
        this.fc_v8_61_unterlage.setValue(this.bsp?.v8_61_unterlage);
        this.fc_v8_62_antwort.setValue(this.bsp?.v8_62_antwort);
        this.fc_v8_62_unterlage.setValue(this.bsp?.v8_62_unterlage);
        this.fc_v8_63_antwort.setValue(this.bsp?.v8_63_antwort);
        this.fc_v8_63_unterlage.setValue(this.bsp?.v8_63_unterlage);
        this.fc_v8_64_antwort.setValue(this.bsp?.v8_64_antwort);
        this.fc_v8_64_unterlage.setValue(this.bsp?.v8_64_unterlage);
        this.fc_v8_65_antwort.setValue(this.bsp?.v8_65_antwort);
        this.fc_v8_65_unterlage.setValue(this.bsp?.v8_65_unterlage);
        this.fc_v8_66_antwort.setValue(this.bsp?.v8_66_antwort);
        this.fc_v8_66_unterlage.setValue(this.bsp?.v8_66_unterlage);
        this.fc_v8_67_antwort.setValue(this.bsp?.v8_67_antwort);
        this.fc_v8_67_unterlage.setValue(this.bsp?.v8_67_unterlage);
        this.fc_v8_68_antwort.setValue(this.bsp?.v8_68_antwort);
        this.fc_v8_68_unterlage.setValue(this.bsp?.v8_68_unterlage);
        this.fc_v8_69_antwort.setValue(this.bsp?.v8_69_antwort);
        this.fc_v8_69_unterlage.setValue(this.bsp?.v8_69_unterlage);
        this.fc_v8_70_antwort.setValue(this.bsp?.v8_70_antwort);
        this.fc_v8_70_unterlage.setValue(this.bsp?.v8_70_unterlage);
        this.fc_v8_71_antwort.setValue(this.bsp?.v8_71_antwort);
        this.fc_v8_71_unterlage.setValue(this.bsp?.v8_71_unterlage);
        this.fc_v8_72_antwort.setValue(this.bsp?.v8_72_antwort);
        this.fc_v8_72_unterlage.setValue(this.bsp?.v8_72_unterlage);
        this.fc_v8_73_handlungsbedarf.setValue(this.bsp?.v8_73_handlungsbedarf);
        this.fc_v8_73_einfriedung.setValue(this.bsp?.v8_73_einfriedung);
        this.fc_v8_73_geschlossen.setValue(this.bsp?.v8_73_geschlossen);
        this.fc_v8_73_beschilderung.setValue(this.bsp?.v8_73_beschilderung);
        this.fc_v8_73_auslauf.setValue(this.bsp?.v8_73_auslauf);
        this.fc_v8_73_sonstiges.setValue(this.bsp?.v8_73_sonstiges);
        this.fc_v8_73_antwort.setValue(this.bsp?.v8_73_antwort);
        this.fc_v8_73_unterlage.setValue(this.bsp?.v8_73_unterlage);
        this.fc_v8_74_handlungsbedarf.setValue(this.bsp?.v8_74_handlungsbedarf);
        this.fc_v8_74_antwort.setValue(this.bsp?.v8_74_antwort);
        this.fc_v8_74_unterlage.setValue(this.bsp?.v8_74_unterlage);
        this.fc_v8_75_handlungsbedarf.setValue(this.bsp?.v8_75_handlungsbedarf);
        this.fc_v8_75_antwort.setValue(this.bsp?.v8_75_antwort);
        this.fc_v8_75_unterlage.setValue(this.bsp?.v8_75_unterlage);
        this.fc_v8_76_handlungsbedarf.setValue(this.bsp?.v8_76_handlungsbedarf);
        this.fc_v8_76_antwort.setValue(this.bsp?.v8_76_antwort);
        this.fc_v8_76_unterlage.setValue(this.bsp?.v8_76_unterlage);
        this.fc_v8_77_handlungsbedarf.setValue(this.bsp?.v8_77_handlungsbedarf);
        this.fc_v8_77_antwort.setValue(this.bsp?.v8_77_antwort);
        this.fc_v8_77_unterlage.setValue(this.bsp?.v8_77_unterlage);
        this.fc_v8_78_handlungsbedarf.setValue(this.bsp?.v8_78_handlungsbedarf);
        this.fc_v8_78_antwort.setValue(this.bsp?.v8_78_antwort);
        this.fc_v8_78_unterlage.setValue(this.bsp?.v8_78_unterlage);
        this.fc_v8_79_handlungsbedarf.setValue(this.bsp?.v8_79_handlungsbedarf);
        this.fc_v8_79_antwort.setValue(this.bsp?.v8_79_antwort);
        this.fc_v8_79_unterlage.setValue(this.bsp?.v8_79_unterlage);
        this.fc_v8_80_handlungsbedarf.setValue(this.bsp?.v8_80_handlungsbedarf);
        this.fc_v8_80_antwort.setValue(this.bsp?.v8_80_antwort);
        this.fc_v8_80_unterlage.setValue(this.bsp?.v8_80_unterlage);
        this.fc_v8_81_handlungsbedarf.setValue(this.bsp?.v8_81_handlungsbedarf);
        this.fc_v8_81_antwort.setValue(this.bsp?.v8_81_antwort);
        this.fc_v8_81_unterlage.setValue(this.bsp?.v8_81_unterlage);
        this.fc_v8_82_handlungsbedarf.setValue(this.bsp?.v8_82_handlungsbedarf);
        this.fc_v8_82_antwort.setValue(this.bsp?.v8_82_antwort);
        this.fc_v8_82_unterlage.setValue(this.bsp?.v8_82_unterlage);
        this.fc_v8_83_handlungsbedarf.setValue(this.bsp?.v8_83_handlungsbedarf);
        this.fc_v8_83_antwort.setValue(this.bsp?.v8_83_antwort);
        this.fc_v8_83_unterlage.setValue(this.bsp?.v8_83_unterlage);
        this.fc_v8_84_handlungsbedarf.setValue(this.bsp?.v8_84_handlungsbedarf);
        this.fc_v8_84_antwort.setValue(this.bsp?.v8_84_antwort);
        this.fc_v8_84_unterlage.setValue(this.bsp?.v8_84_unterlage);
        this.fc_v8_85_handlungsbedarf.setValue(this.bsp?.v8_85_handlungsbedarf);
        this.fc_v8_85_antwort.setValue(this.bsp?.v8_85_antwort);
        this.fc_v8_85_unterlage.setValue(this.bsp?.v8_85_unterlage);
        this.fc_v8_86_handlungsbedarf.setValue(this.bsp?.v8_86_handlungsbedarf);
        this.fc_v8_86_antwort.setValue(this.bsp?.v8_86_antwort);
        this.fc_v8_86_unterlage.setValue(this.bsp?.v8_86_unterlage);
        this.fc_v8_87_handlungsbedarf.setValue(this.bsp?.v8_87_handlungsbedarf);
        this.fc_v8_87_schleuse.setValue(this.bsp?.v8_87_schleuse);
        this.fc_v8_87_ort_schleuse.setValue(this.bsp?.v8_87_ort_schleuse);
        this.fc_v8_87_antwort.setValue(this.bsp?.v8_87_antwort);
        this.fc_v8_87_unterlage.setValue(this.bsp?.v8_87_unterlage);
        this.fc_v8_88_handlungsbedarf.setValue(this.bsp?.v8_88_handlungsbedarf);
        this.fc_v8_88_antwort.setValue(this.bsp?.v8_88_antwort);
        this.fc_v8_88_unterlage.setValue(this.bsp?.v8_88_unterlage);
        this.fc_v8_89_handlungsbedarf.setValue(this.bsp?.v8_89_handlungsbedarf);
        this.fc_v8_89_antwort.setValue(this.bsp?.v8_89_antwort);
        this.fc_v8_89_unterlage.setValue(this.bsp?.v8_89_unterlage);
        this.fc_v9_90_handlungsbedarf.setValue(this.bsp?.v9_90_handlungsbedarf);
        this.fc_v9_90_antwort.setValue(this.bsp?.v9_90_antwort);
        this.fc_v9_90_unterlage.setValue(this.bsp?.v9_90_unterlage);
        this.fc_v9_91_handlungsbedarf.setValue(this.bsp?.v9_91_handlungsbedarf);
        this.fc_v9_91_antwort.setValue(this.bsp?.v9_91_antwort);
        this.fc_v9_91_unterlage.setValue(this.bsp?.v9_91_unterlage);
        this.fc_v10_92_handlungsbedarf.setValue(this.bsp?.v10_92_handlungsbedarf);
        this.fc_v10_92_bestandsregister.setValue(this.bsp?.v10_92_bestandsregister);
        this.fc_v10_92_berechnung_verluste.setValue(this.bsp?.v10_92_berechnung_verluste);
        this.fc_v10_92_sauenplaner.setValue(this.bsp?.v10_92_sauenplaner);
        this.fc_v10_92_mastplaner.setValue(this.bsp?.v10_92_mastplaner);
        this.fc_v10_92_nach_aufzeichnungen.setValue(this.bsp?.v10_92_nach_aufzeichnungen);
        this.fc_v10_92_antwort.setValue(this.bsp?.v10_92_antwort);
        this.fc_v10_92_unterlage.setValue(this.bsp?.v10_92_unterlage);
        this.fc_v10_93_handlungsbedarf.setValue(this.bsp?.v10_93_handlungsbedarf);
        this.fc_v10_93_mindestens.setValue(this.bsp?.v10_93_mindestens);
        this.fc_v10_93_mit_hilfe.setValue(this.bsp?.v10_93_mit_hilfe);
        this.fc_v10_93_antwort.setValue(this.bsp?.v10_93_antwort);
        this.fc_v10_93_unterlage.setValue(this.bsp?.v10_93_unterlage);
        this.fc_v10_94_handlungsbedarf.setValue(this.bsp?.v10_94_handlungsbedarf);
        this.fc_v10_94_antwort.setValue(this.bsp?.v10_94_antwort);
        this.fc_v10_94_unterlage.setValue(this.bsp?.v10_94_unterlage);
        this.fc_v10_95_handlungsbedarf.setValue(this.bsp?.v10_95_handlungsbedarf);
        this.fc_v10_95_antwort.setValue(this.bsp?.v10_95_antwort);
        this.fc_v10_95_unterlage.setValue(this.bsp?.v10_95_unterlage);
        this.fc_v10_96_handlungsbedarf.setValue(this.bsp?.v10_96_handlungsbedarf);
        this.fc_v10_96_antwort.setValue(this.bsp?.v10_96_antwort);
        this.fc_v10_96_unterlage.setValue(this.bsp?.v10_96_unterlage);
        this.fc_v10_97_handlungsbedarf.setValue(this.bsp?.v10_97_handlungsbedarf);
        this.fc_v10_97_antwort.setValue(this.bsp?.v10_97_antwort);
        this.fc_v10_97_unterlage.setValue(this.bsp?.v10_97_unterlage);
        this.fc_v10_98_handlungsbedarf.setValue(this.bsp?.v10_98_handlungsbedarf);
        this.fc_v10_98_antwort.setValue(this.bsp?.v10_98_antwort);
        this.fc_v10_98_unterlage.setValue(this.bsp?.v10_98_unterlage);
        this.fc_v10_99_handlungsbedarf.setValue(this.bsp?.v10_99_handlungsbedarf);
        this.fc_v10_99_antwort.setValue(this.bsp?.v10_99_antwort);
        this.fc_v10_99_unterlage.setValue(this.bsp?.v10_99_unterlage);
        this.fc_v11_100_handlungsbedarf.setValue(this.bsp?.v11_100_handlungsbedarf);
        this.fc_v11_100_mastbetrieb.setValue(this.bsp?.v11_100_mastbetrieb);
        this.fc_v11_100_zusammenschluss.setValue(this.bsp?.v11_100_zusammenschluss);
        this.fc_v11_100_ab_stall.setValue(this.bsp?.v11_100_ab_stall);
        this.fc_v11_100_antwort.setValue(this.bsp?.v11_100_antwort);
        this.fc_v11_100_unterlage.setValue(this.bsp?.v11_100_unterlage);
        this.fc_v11_101_handlungsbedarf.setValue(this.bsp?.v11_101_handlungsbedarf);
        this.fc_v11_101_antwort.setValue(this.bsp?.v11_101_antwort);
        this.fc_v11_101_unterlage.setValue(this.bsp?.v11_101_unterlage);
        this.fc_v11_102_handlungsbedarf.setValue(this.bsp?.v11_102_handlungsbedarf);
        this.fc_v11_102_antwort.setValue(this.bsp?.v11_102_antwort);
        this.fc_v11_102_unterlage.setValue(this.bsp?.v11_102_unterlage);
        this.fc_v11_103_handlungsbedarf.setValue(this.bsp?.v11_103_handlungsbedarf);
        this.fc_v11_103_antwort.setValue(this.bsp?.v11_103_antwort);
        this.fc_v11_103_unterlage.setValue(this.bsp?.v11_103_unterlage);
        this.fc_v11_104_handlungsbedarf.setValue(this.bsp?.v11_104_handlungsbedarf);
        this.fc_v11_104_antwort.setValue(this.bsp?.v11_104_antwort);
        this.fc_v11_104_unterlage.setValue(this.bsp?.v11_104_unterlage);
        this.fc_v11_105_handlungsbedarf.setValue(this.bsp?.v11_105_handlungsbedarf);
        this.fc_v11_105_antwort.setValue(this.bsp?.v11_105_antwort);
        this.fc_v11_105_unterlage.setValue(this.bsp?.v11_105_unterlage);
        this.fc_v11_106_handlungsbedarf.setValue(this.bsp?.v11_106_handlungsbedarf);
        this.fc_v11_106_antwort.setValue(this.bsp?.v11_106_antwort);
        this.fc_v11_106_unterlage.setValue(this.bsp?.v11_106_unterlage);
        this.fc_v11_107_handlungsbedarf.setValue(this.bsp?.v11_107_handlungsbedarf);
        this.fc_v11_107_antwort.setValue(this.bsp?.v11_107_antwort);
        this.fc_v11_107_unterlage.setValue(this.bsp?.v11_107_unterlage);
        this.fc_v11_108_handlungsbedarf.setValue(this.bsp?.v11_108_handlungsbedarf);
        this.fc_v11_108_antwort.setValue(this.bsp?.v11_108_antwort);
        this.fc_v11_108_unterlage.setValue(this.bsp?.v11_108_unterlage);
        this.fc_v11_109_handlungsbedarf.setValue(this.bsp?.v11_109_handlungsbedarf);
        this.fc_v11_109_antwort.setValue(this.bsp?.v11_109_antwort);
        this.fc_v11_109_unterlage.setValue(this.bsp?.v11_109_unterlage);
        this.fc_v12_110_handlungsbedarf.setValue(this.bsp?.v12_110_handlungsbedarf);
        this.fc_v12_110_antwort.setValue(this.bsp?.v12_110_antwort);
        this.fc_v12_110_unterlage.setValue(this.bsp?.v12_110_unterlage);
        this.fc_v12_111_handlungsbedarf.setValue(this.bsp?.v12_111_handlungsbedarf);
        this.fc_v12_111_antwort.setValue(this.bsp?.v12_111_antwort);
        this.fc_v12_111_unterlage.setValue(this.bsp?.v12_111_unterlage);
        this.fc_v12_112_handlungsbedarf.setValue(this.bsp?.v12_112_handlungsbedarf);
        this.fc_v12_112_antwort.setValue(this.bsp?.v12_112_antwort);
        this.fc_v12_112_unterlage.setValue(this.bsp?.v12_112_unterlage);
        this.fc_v12_113_handlungsbedarf.setValue(this.bsp?.v12_113_handlungsbedarf);
        this.fc_v12_113_antwort.setValue(this.bsp?.v12_113_antwort);
        this.fc_v12_113_unterlage.setValue(this.bsp?.v12_113_unterlage);
        this.fc_v12_114_handlungsbedarf.setValue(this.bsp?.v12_114_handlungsbedarf);
        this.fc_v12_114_antwort.setValue(this.bsp?.v12_114_antwort);
        this.fc_v12_114_unterlage.setValue(this.bsp?.v12_114_unterlage);
        this.fc_v13_115_handlungsbedarf.setValue(this.bsp?.v13_115_handlungsbedarf);
        this.fc_v13_115_antwort.setValue(this.bsp?.v13_115_antwort);
        this.fc_v13_115_unterlage.setValue(this.bsp?.v13_115_unterlage);
        this.fc_v13_116_handlungsbedarf.setValue(this.bsp?.v13_116_handlungsbedarf);
        this.fc_v13_116_antwort.setValue(this.bsp?.v13_116_antwort);
        this.fc_v13_116_unterlage.setValue(this.bsp?.v13_116_unterlage);
        this.fc_v13_117_handlungsbedarf.setValue(this.bsp?.v13_117_handlungsbedarf);
        this.fc_v13_117_antwort.setValue(this.bsp?.v13_117_antwort);
        this.fc_v13_117_unterlage.setValue(this.bsp?.v13_117_unterlage);
        this.fc_v13_118_handlungsbedarf.setValue(this.bsp?.v13_118_handlungsbedarf);
        this.fc_v13_118_antwort.setValue(this.bsp?.v13_118_antwort);
        this.fc_v13_118_unterlage.setValue(this.bsp?.v13_118_unterlage);
        this.fc_v13_119_handlungsbedarf.setValue(this.bsp?.v13_119_handlungsbedarf);
        this.fc_v13_119_antwort.setValue(this.bsp?.v13_119_antwort);
        this.fc_v13_119_unterlage.setValue(this.bsp?.v13_119_unterlage);
        this.fc_v14_120_handlungsbedarf.setValue(this.bsp?.v14_120_handlungsbedarf);
        this.fc_v14_120_antwort.setValue(this.bsp?.v14_120_antwort);
        this.fc_v14_120_unterlage.setValue(this.bsp?.v14_120_unterlage);
        this.fc_v14_121_handlungsbedarf.setValue(this.bsp?.v14_121_handlungsbedarf);
        this.fc_v14_121_antwort.setValue(this.bsp?.v14_121_antwort);
        this.fc_v14_121_unterlage.setValue(this.bsp?.v14_121_unterlage);
        this.fc_v14_122_handlungsbedarf.setValue(this.bsp?.v14_122_handlungsbedarf);
        this.fc_v14_122_antwort.setValue(this.bsp?.v14_122_antwort);
        this.fc_v14_122_unterlage.setValue(this.bsp?.v14_122_unterlage);
        // Frage 123
        this.fc_v123_zu_nr.setValue(this.bsp?.v123_zu_nr);
        this.fc_v123_erledigt.setValue(this.bsp?.v123_erledigt);
        this.fc_v123_schwachstelle.setValue(this.bsp?.v123_schwachstelle);
        this.fc_v123_handlungsempfehlung.setValue(this.bsp?.v123_handlungsempfehlung);
        this.fc_v123_unterlage.setValue(this.bsp?.v123_unterlage);

        // Frage 124
        this.fc_v124_zu_nr.setValue(this.bsp?.v124_zu_nr);
        this.fc_v124_erledigt.setValue(this.bsp?.v124_erledigt);
        this.fc_v124_schwachstelle.setValue(this.bsp?.v124_schwachstelle);
        this.fc_v124_handlungsempfehlung.setValue(this.bsp?.v124_handlungsempfehlung);
        this.fc_v124_unterlage.setValue(this.bsp?.v124_unterlage);

        // Frage 125
        this.fc_v125_zu_nr.setValue(this.bsp?.v125_zu_nr);
        this.fc_v125_erledigt.setValue(this.bsp?.v125_erledigt);
        this.fc_v125_schwachstelle.setValue(this.bsp?.v125_schwachstelle);
        this.fc_v125_handlungsempfehlung.setValue(this.bsp?.v125_handlungsempfehlung);
        this.fc_v125_unterlage.setValue(this.bsp?.v125_unterlage);

        // Zusätzliche Handlungsempfehlungen (dynamisch)
        this.fc_v126_zu_nr.setValue(this.bsp?.v126_zu_nr);
        this.fc_v126_erledigt.setValue(!!this.bsp?.v126_erledigt);
        this.fc_v126_schwachstelle.setValue(this.bsp?.v126_schwachstelle);
        this.fc_v126_handlungsempfehlung.setValue(this.bsp?.v126_handlungsempfehlung);
        this.fc_v126_unterlage.setValue(this.bsp?.v126_unterlage);

        // Zusätzliche Handlungsempfehlungen v127-v132
        this.fc_v127_zu_nr.setValue(this.bsp?.v127_zu_nr);
        this.fc_v127_erledigt.setValue(!!this.bsp?.v127_erledigt);
        this.fc_v127_schwachstelle.setValue(this.bsp?.v127_schwachstelle);
        this.fc_v127_handlungsempfehlung.setValue(this.bsp?.v127_handlungsempfehlung);
        this.fc_v127_unterlage.setValue(this.bsp?.v127_unterlage);

        this.fc_v128_zu_nr.setValue(this.bsp?.v128_zu_nr);
        this.fc_v128_erledigt.setValue(!!this.bsp?.v128_erledigt);
        this.fc_v128_schwachstelle.setValue(this.bsp?.v128_schwachstelle);
        this.fc_v128_handlungsempfehlung.setValue(this.bsp?.v128_handlungsempfehlung);
        this.fc_v128_unterlage.setValue(this.bsp?.v128_unterlage);

        this.fc_v129_zu_nr.setValue(this.bsp?.v129_zu_nr);
        this.fc_v129_erledigt.setValue(!!this.bsp?.v129_erledigt);
        this.fc_v129_schwachstelle.setValue(this.bsp?.v129_schwachstelle);
        this.fc_v129_handlungsempfehlung.setValue(this.bsp?.v129_handlungsempfehlung);
        this.fc_v129_unterlage.setValue(this.bsp?.v129_unterlage);

        this.fc_v130_zu_nr.setValue(this.bsp?.v130_zu_nr);
        this.fc_v130_erledigt.setValue(!!this.bsp?.v130_erledigt);
        this.fc_v130_schwachstelle.setValue(this.bsp?.v130_schwachstelle);
        this.fc_v130_handlungsempfehlung.setValue(this.bsp?.v130_handlungsempfehlung);
        this.fc_v130_unterlage.setValue(this.bsp?.v130_unterlage);

        this.fc_v131_zu_nr.setValue(this.bsp?.v131_zu_nr);
        this.fc_v131_erledigt.setValue(!!this.bsp?.v131_erledigt);
        this.fc_v131_schwachstelle.setValue(this.bsp?.v131_schwachstelle);
        this.fc_v131_handlungsempfehlung.setValue(this.bsp?.v131_handlungsempfehlung);
        this.fc_v131_unterlage.setValue(this.bsp?.v131_unterlage);

        this.fc_v132_zu_nr.setValue(this.bsp?.v132_zu_nr);
        this.fc_v132_erledigt.setValue(!!this.bsp?.v132_erledigt);
        this.fc_v132_schwachstelle.setValue(this.bsp?.v132_schwachstelle);
        this.fc_v132_handlungsempfehlung.setValue(this.bsp?.v132_handlungsempfehlung);
        this.fc_v132_unterlage.setValue(this.bsp?.v132_unterlage);

        // Initialisiere dynamische Handlungsempfehlungen
        this.initDynamicHandlungsempfehlungen();
        this.syncReadOnlyFormControls();
    }

    private initDynamicHandlungsempfehlungen(): void {
        // Leere das Array
        this.handlungsempfehlungen = [];

        // Prüfe die statischen Felder v126 bis v132 und erstelle dynamische Einträge
        // Erstelle Einträge für alle Felder, die in der Datenbank existieren (auch leere)
        for (let i = 126; i <= 132; i++) {
            const zu_nr = this.bsp[`v${i}_zu_nr`];
            const schwachstelle = this.bsp[`v${i}_schwachstelle`];
            const handlungsempfehlung = this.bsp[`v${i}_handlungsempfehlung`];
            const erledigt = this.bsp[`v${i}_erledigt`];
            const unterlage = this.bsp[`v${i}_unterlage`];

            // Erstelle Eintrag nur wenn mindestens ein Feld tatsächlichen Inhalt hat (nicht leerer String)
            const hasContent =
                (zu_nr && zu_nr.trim() !== '') ||
                (schwachstelle && schwachstelle.trim() !== '') ||
                (handlungsempfehlung && handlungsempfehlung.trim() !== '') ||
                erledigt === 1 ||
                erledigt === true ||
                (unterlage && unterlage.trim() !== '');

            if (hasContent) {
                const handlungsempfehlungEintrag: HandlungsempfehlungEintrag = new HandlungsempfehlungEintrag();
                handlungsempfehlungEintrag.id = this.handlungsempfehlungen.length;
                handlungsempfehlungEintrag.bs_id = this.bsp?.bs_id;
                handlungsempfehlungEintrag.zu_nr = new FormControl(zu_nr || '');
                handlungsempfehlungEintrag.erledigt = new FormControl(erledigt === 1 || erledigt === true);
                handlungsempfehlungEintrag.schwachstelle = new FormControl(schwachstelle || '');
                handlungsempfehlungEintrag.handlungsempfehlung = new FormControl(handlungsempfehlung || '');
                handlungsempfehlungEintrag.unterlage = new FormControl(unterlage || '');
                handlungsempfehlungEintrag.isNew = false;
                this.handlungsempfehlungen.push(handlungsempfehlungEintrag);
            }
        }
    }

    private prepareReinigungFormModels() {
        const reinigungen: BioSicherheitPlanSchweinReinigung[] = [];

        for (let i = 0; i < this.reinigungsplaene.length; i++) {
            const plan = this.reinigungsplaene[i];
            const eintrag = new BioSicherheitPlanSchweinReinigung();

            eintrag.bs_id = this.bsp.bs_id;
            if (this.bsp?.reinigungen[i]?.bsr_id !== undefined) {
                eintrag.bsr_id = this.bsp?.reinigungen[i].bsr_id;
            }
            const getBool = (index: number) => (plan.formControls[index]?.handlungsbedarf?.value ? 1 : 0);
            const getText = (index: number, key: 'antwort' | 'unterlage' | 'massnahmen') =>
                plan.formControls[index]?.[key]?.value || '';

            eintrag.stall = plan?.fc_stall?.value;
            // Zeilen 29 bis 35
            eintrag.v4_29_handlungsbedarf = getBool(0);
            eintrag.v4_29_antwort = getText(0, 'antwort');
            eintrag.v4_29_unterlage = getText(0, 'unterlage');

            eintrag.v4_30_handlungsbedarf = getBool(1);
            eintrag.v4_30_antwort = getText(1, 'antwort');
            eintrag.v4_30_unterlage = getText(1, 'unterlage');

            eintrag.v4_31_handlungsbedarf = getBool(2);
            eintrag.v4_31_antwort = getText(2, 'antwort');
            eintrag.v4_31_unterlage = getText(2, 'unterlage');

            eintrag.v4_32_handlungsbedarf = getBool(3);
            eintrag.v4_32_antwort = getText(3, 'antwort');
            eintrag.v4_32_unterlage = getText(3, 'unterlage');

            eintrag.v4_33_handlungsbedarf = getBool(4);
            eintrag.v4_33_antwort = getText(4, 'antwort');
            eintrag.v4_33_unterlage = getText(4, 'unterlage');

            eintrag.v4_34_handlungsbedarf = getBool(5);
            eintrag.v4_34_antwort = getText(5, 'antwort');
            eintrag.v4_34_unterlage = getText(5, 'unterlage');

            eintrag.v4_35_handlungsbedarf = getBool(6);
            eintrag.v4_35_massnahmen = getText(6, 'massnahmen');
            eintrag.v4_35_antwort = getText(6, 'antwort');
            eintrag.v4_35_unterlage = getText(6, 'unterlage');

            reinigungen.push(eintrag);
        }
        this.bsp.reinigungen = reinigungen;
    }

    loadReinigungFromModel(): void {
        this.reinigungsplaene = [];

        if (this.bsp?.reinigungen?.length === 0) {
            this.addReinigung();
        }
        if (this.bsp?.reinigungen?.length > 0) {
            for (let i = 0; i < this.bsp.reinigungen?.length; i++) {
                const eintrag = this.bsp.reinigungen[i];

                const formControls: ReinigungFormControls[] = [
                    new ReinigungFormControls(
                        eintrag.v4_29_handlungsbedarf,
                        eintrag.v4_29_antwort,
                        eintrag.v4_29_unterlage,
                    ),
                    new ReinigungFormControls(
                        eintrag.v4_30_handlungsbedarf,
                        eintrag.v4_30_antwort,
                        eintrag.v4_30_unterlage,
                    ),
                    new ReinigungFormControls(
                        eintrag.v4_31_handlungsbedarf,
                        eintrag.v4_31_antwort,
                        eintrag.v4_31_unterlage,
                    ),
                    new ReinigungFormControls(
                        eintrag.v4_32_handlungsbedarf,
                        eintrag.v4_32_antwort,
                        eintrag.v4_32_unterlage,
                    ),
                    new ReinigungFormControls(
                        eintrag.v4_33_handlungsbedarf,
                        eintrag.v4_33_antwort,
                        eintrag.v4_33_unterlage,
                    ),
                    new ReinigungFormControls(
                        eintrag.v4_34_handlungsbedarf,
                        eintrag.v4_34_antwort,
                        eintrag.v4_34_unterlage,
                    ),
                    new ReinigungFormControls(
                        eintrag.v4_35_handlungsbedarf,
                        eintrag.v4_35_antwort,
                        eintrag.v4_35_unterlage,
                        eintrag.v4_35_massnahmen,
                    ),
                ];

                const buchstabe = String.fromCharCode(65 + i); // A, B, C, ...

                const reinigungsEintrag: Reinigungseintrag = {
                    fc_stall: new FormControl(eintrag?.stall || ''),
                    id: i,
                    formControls,
                    bsr_id: eintrag?.bsr_id,
                    bs_id: this.bsp.bs_id,
                };

                this.reinigungsplaene.push(reinigungsEintrag);
            }
        }
    }

    ladeBenutzerprofil() {
        this.api.get(this.apiBaseUrl + 'benutzerprofil/read_one_kundenportal.php').subscribe({
            next: response => {
                this.benutzerprofil = <Benutzerprofil>response;
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    abschliessen(): void {
        if (!this.bsp?.bs_id) {
            this.messageService.hintMessage('Bitte warten, bis der Plan vollständig geladen ist.');
            return;
        }
        if (!this.bsp?.kunde_id) {
            this.messageService.hintMessage(
                'Abschließen nicht möglich: Kein Betrieb (Kunde) am Plan. Bitte wählen Sie den Betrieb aus.',
            );
            return;
        }
        const tierarztId =
            (this.bsp?.tierarzt_id > 0 ? this.bsp.tierarzt_id : null) ??
            this.localStorageService.getCurrentUser()?.tierarzt_id;
        if (tierarztId != null && tierarztId > 0) {
            this.bsp.tierarzt_id = tierarztId;
        }
        if (this.bsp.status_id === 232 || this.bsp.status_id === 250 || this.bsp.status_id === 251) {
            this.showFinishedPdf(this.bsp);
            return;
        }
        this.saveBSP(undefined, { statusIdForSave: 232, abschlussOnly: true });
    }

    onBeraterNameChanged(): void {
        if (!this.hasBerater()) {
            this.clearBeraterFields();
        }
        this.saveBspTimeout();
    }

    persistBeraterKuidToPlan(kuid: string): void {
        if (!this.hasBerater()) {
            return;
        }
        const k = (kuid || '').trim();
        if (!k || !this.bsp?.bs_id || this.isReadOnly()) {
            return;
        }
        this.bsp.berater_kuid = k;
        this.isSaving = true;
        this.api
            .post(this.apiBaseUrl + 'biosicherheitsplan_schwein/update_unterschrift.php', {
                bs_id: this.bsp.bs_id,
                berater_kuid: k,
            })
            .subscribe({
                next: () => {
                    this.isSaving = false;
                    this.loadPlan(this.bsp.bs_id);
                },
                error: err => {
                    this.isSaving = false;
                    this.messageService.errorMessage('Berater-KUID konnte nicht am Plan gespeichert werden.', err);
                },
            });
    }

    onBeraterSignDialogClosed(): void {
        if (!this.bsp?.bs_id || !this.hasBerater()) {
            return;
        }
        const beraterKuid = (this.bsp.berater_kuid || '').trim();
        if (!beraterKuid) {
            this.loadPlan(this.bsp.bs_id);
            return;
        }
        this.api
            .post(this.apiBaseUrl + 'biosicherheitsplan_schwein/update_unterschrift.php', {
                bs_id: this.bsp.bs_id,
                berater_kuid: beraterKuid,
            })
            .subscribe({
                next: () => this.loadPlan(this.bsp.bs_id),
                error: () => this.loadPlan(this.bsp.bs_id),
            });
    }

    persistKuidToPlan(kuid: string): void {
        const k = (kuid || '').trim();
        if (!k || !this.bsp?.bs_id || this.isReadOnly()) {
            return;
        }
        this.bsp.kuid = k;
        this.isSaving = true;
        this.api
            .post(this.apiBaseUrl + 'biosicherheitsplan_schwein/update_unterschrift.php', {
                bs_id: this.bsp.bs_id,
                kuid: k,
            })
            .subscribe({
                next: () => {
                    this.isSaving = false;
                    this.loadPlan(this.bsp.bs_id);
                },
                error: err => {
                    this.isSaving = false;
                    this.messageService.errorMessage('KUID konnte nicht am Plan gespeichert werden.', err);
                },
            });
    }

    onSignDialogClosed(): void {
        if (!this.bsp?.bs_id) {
            return;
        }
        const kuid = (this.bsp.kuid || '').trim();
        if (!kuid) {
            this.loadPlan(this.bsp.bs_id);
            return;
        }
        this.api
            .post(this.apiBaseUrl + 'biosicherheitsplan_schwein/update_unterschrift.php', {
                bs_id: this.bsp.bs_id,
                kuid,
            })
            .subscribe({
                next: () => this.loadPlan(this.bsp.bs_id),
                error: () => this.loadPlan(this.bsp.bs_id),
            });
    }

    getBuchstabe(idx: number): string {
        return String.fromCharCode(65 + idx);
    }

    trackByIndex(i: number): number {
        return i;
    }

    getAdresse(): string {
        let adresse = '';
        if (this.bsp?.plz != null) {
            adresse += this.bsp.plz + ' ';
        }
        if (this.bsp?.ort != null) {
            adresse += this.bsp.ort;
        }
        if (this.bsp?.strasse != null) {
            adresse += ', ' + this.bsp.strasse;
        }
        return adresse;
    }

    setLieferadresse() {
        if (this.bsp?.v1_13_standort_adresse != null) {
            this.fc_v1_13_standort_adresse.setValue(this.bsp?.v1_13_standort_adresse);
        } else if (
            this.bsp?.plz_lieferung != null &&
            this.bsp?.ort_lieferung != null &&
            this.bsp?.strasse_lieferung != null
        ) {
            this.fc_v1_13_standort_adresse.setValue(
                this.bsp?.plz_lieferung + ' ' + this.bsp?.ort_lieferung + ', ' + this.bsp?.strasse_lieferung,
            );
        } else {
            this.fc_v1_13_standort_adresse.setValue(this.getAdresse());
        }
    }

    handleFileButtonClick(fileInput: HTMLInputElement): void {
        fileInput.click(); // Datei-Dialog öffnen
    }

    onFileChange(event: Event, sektion: string) {
        const input = event.target as HTMLInputElement;

        const allowedExtensions = ['pdf'];
        const file = input.files[0];
        const ext = file.name.split('.').pop()?.toLowerCase();
        if (ext && allowedExtensions.includes(ext)) {
            const fileData = new BioSicherheitsPlanFile();
            fileData.bs_id = this.bsp.bs_id;
            fileData.file = file;
            fileData.sektion = sektion;
            fileData.isNew = true;
            this.selectedFiles.push(fileData);

            if (!this.bsp.bs_id) {
                this.saveBSP(fileData);
            } else {
                this.saveNewFiles2(fileData);
            }
        } else {
            this.messageService.alertMessage(
                'Die Datei ' + file.name + ' hat eine unerlaubte Endung und wurde übersprungen.',
            );
        }
    }

    private saveNewFiles2(datei: BioSicherheitsPlanFile) {
        this.isSaving = true;
        const fd = new FormData();
        fd.set('bs_id', this.bsp.bs_id.toString());
        fd.set('sektion', datei.sektion);
        fd.set('dateiname', datei.file.name);
        fd.append('dokument', datei.file);

        const options = { headers: new HttpHeaders('Phito-Type: fileupload'), reportProgress: true };

        this.api
            .postFormData(this.apiBaseUrl + 'biosicherheitsplan_schwein_dokuments/create.php', fd, options)
            .subscribe({
                next: (response: { bsd_id?: number; pdf_id?: number }) => {
                    const createdId = Number(response?.bsd_id || 0);
                    if (createdId > 0) {
                        datei.bsd_id = createdId;
                        datei.pdf_id = Number(response?.pdf_id || 0);
                        datei.dateiname = datei.file?.name || datei.dateiname;
                        datei.isNew = false;
                    }
                    this.ladeBspPdfs();
                    this.messageService.infoMessage('Pdf wurde gespeichert.');
                    this.ladeBspPdfs();
                    this.initFormControls();
                    this.syncReadOnlyFormControls();
                    this.aktualisiereBrowserUrl();
                    this.isSaving = false;
                },
                error: err => {
                    this.messageService.errorMessage('Upload fehlgeschlagen', err);
                    this.isSaving = false;
                },
            });
    }

    removeFile(bspf: BioSicherheitsPlanFile, sektion: string) {
        const input = new ConfirmDialogInput();
        input.headline = 'Datei löschen';
        input.text = 'Möchten Sie die Datei wirklich löschen?';
        input.okButton = 'Ja';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe((result: ConfirmDialogResult) => {
                if (result?.ok && result?.confirmed) {
                    this.isSaving = true;
                    this.api
                        .deleteEntity(this.apiBaseUrl + 'biosicherheitsplan_schwein_dokuments/delete.php', bspf)
                        .subscribe({
                            next: () => {
                                this.isSaving = false;
                                this.ladeBspPdfs();
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler beim löschen der Datei', err);
                                this.isSaving = false;
                            },
                        });
                }
            });
    }

    getSektionFiles(sektion: string) {
        return this.selectedFiles.filter(b => b.sektion === sektion);
    }

    showFilePdf(biofile: BioSicherheitsPlanFile) {
        const titel = 'Bio-Sicherheitsplan - Vorschau Dokument: ' + (biofile.file?.name ?? biofile.dateiname);
        if (!biofile?.bsd_id) {
            this.messageService.hintMessage(
                'Dokument wird noch gespeichert. Bitte kurz warten und erneut versuchen.',
            );
            if (this.bsp?.bs_id) {
                this.ladeBspPdfs();
            }
            return;
        }
        let params = new HttpParams().set('bsd_id', String(biofile.bsd_id));
        if (biofile.pdf_id) {
            params = params.set('pdf_id', String(biofile.pdf_id));
        }
        const input = new PdfViewerDialogInput(
            'biosicherheitsplan_schwein_dokuments/read_or_mail_pdf.php',
            params,
            titel,
            { email: { sende_mail: false, kunde_id: this.bsp?.kunde_id } },
        );
        this.pdf.openPdfViewer(input);
    }

    openTSKDialog() {
        const input = new EnterValueInput();
        input.addInputValue('TSK - Nummer', 'numeric', this.bsp?.tsk_nummer);
        input.title = 'TSK-Nummer';
        input.text = 'Geben Sie die TSK-Nummer ein.';
        this.dialog
            .open(EnterValueDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: EnterValueResponse) => {
                    const kunde = new Client();
                    kunde.kunde_id = this.bsp?.kunde_id;
                    kunde.tsk_nummer = result.getValue(0).toString();
                    this.api.post(this.apiBaseUrl + 'kunde/update_tsk_kundenportal.php', kunde).subscribe({
                        next: (response: Client) => {
                            this.bsp.tsk_nummer = response.tsk_nummer;
                            this.saveBSP();
                        },
                        error: err => {
                            this.messageService.errorMessage('Kunde konnte nicht gespeichert (TSK - Nummer )', err);
                        },
                    });
                },
            });
    }

    betriebAendern() {
        this.changeClientSub?.unsubscribe();
        this.changeClientSub = this.changeCurrentClientService
            .openChangeDialog({ nurSchweinebetriebe: true })
            .subscribe({
                next: (client: Client) => {
                    if (client) {
                        if (!this.bsp?.kunde_id || this.bsp?.kunde_id != client.kunde_id) {
                            this.bsp.kunde_id = client.kunde_id;
                            this.bsp.kuid = null;
                            this.saveBSP();
                        }
                    }
                },
            });
    }

    addHandlungsempfehlung() {
        const handlungsempfehlung: HandlungsempfehlungEintrag = new HandlungsempfehlungEintrag();
        handlungsempfehlung.id = this.handlungsempfehlungen.length;
        handlungsempfehlung.bs_id = this.bsp?.bs_id;
        handlungsempfehlung.zu_nr = new FormControl('');
        handlungsempfehlung.erledigt = new FormControl(false);
        handlungsempfehlung.schwachstelle = new FormControl('');
        handlungsempfehlung.handlungsempfehlung = new FormControl('');
        handlungsempfehlung.unterlage = new FormControl('');
        handlungsempfehlung.isNew = true;
        this.handlungsempfehlungen.push(handlungsempfehlung);
    }

    removeHandlungsempfehlung(handlungsempfehlung: HandlungsempfehlungEintrag): void {
        const input = new ConfirmDialogInput();
        input.headline = 'Handlungsempfehlung löschen';
        input.text = 'Möchten Sie diese Handlungsempfehlung wirklich löschen?';
        input.okButton = 'Ja';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe((result: ConfirmDialogResult) => {
                if (result?.ok && result?.confirmed) {
                    const idx = this.handlungsempfehlungen.findIndex(h => h.id === handlungsempfehlung.id);
                    if (idx !== -1) {
                        this.handlungsempfehlungen.splice(idx, 1);
                        this.saveBSP();
                    }
                }
            });
    }
}
